/* Русский — Russian */
const ru = {
  nav: {
    home: 'Главная',
    imageConverter: 'Конвертер изображений',
    imageCompressor: 'Компрессор изображений',
    otherTools: 'Другие инструменты',
    resizeImage: 'Изменить размер',
    cropImage: 'Обрезать изображение',
    photoEditor: 'Фоторедактор',
    removeBackground: 'Удалить фон',
    watermarkImage: 'Водяной знак',
    qrCodeGenerator: 'Генератор QR-кода',
    qrCodeScanner: 'Сканер QR-кода',
    aboutUs: 'О нас',
    faceBlur: 'Размытие лица',
  },
  hero: {
    heading: 'Все инструменты для изображений',
    subheading: 'Бесплатные онлайн-инструменты для конвертации, сжатия, изменения размера, обрезки, редактирования и трансформации изображений. Всё обрабатывается в вашем браузере — быстро, конфиденциально и безопасно.',
  },
  tools: {
    compressImage: { title: 'СЖАТЬ изображение', desc: 'Сжимайте JPG, PNG, SVG и GIF, экономя место и сохраняя качество.' },
    resizeImage: { title: 'ИЗМЕНИТЬ РАЗМЕР', desc: 'Задайте размеры в процентах или пикселях и изменяйте размер JPG, PNG, SVG и GIF.' },
    cropImage: { title: 'ОБРЕЗАТЬ изображение', desc: 'Легко обрезайте JPG, PNG или GIF; укажите пиксели для прямоугольника или используйте наш визуальный редактор.' },
    convertToJpg: { title: 'Конвертировать в JPG', desc: 'Массово конвертируйте PNG, GIF, TIF, PSD, SVG, WEBP, HEIC или RAW в JPG.' },
    convertFromJpg: { title: 'Конвертировать из JPG', desc: 'Преобразуйте JPG в PNG и GIF. Выберите несколько JPG для создания анимированного GIF!' },
    qrCodeGenerator: { title: 'Генератор QR-кода', desc: 'Создавайте QR-коды для URL, текста, WiFi, контактов, email и карт. Настраивайте стили, цвета и логотипы.' },
    qrCodeScanner: { title: 'Сканер QR-кода', desc: 'Мгновенно сканируйте QR-коды с камеры или загруженного изображения. Определяйте URL, текст, WiFi, контакты и многое другое.' },
    blurFace: { title: 'Размытие лица', desc: 'Автоматически обнаруживайте и размывайте лица для защиты конфиденциальности. Настраивайте интенсивность размытия, форму или добавляйте эмодзи.' },
    removeBackground: { title: 'Удалить фон', desc: 'Быстро удаляйте фоны изображений с высокой точностью. Мгновенно определяйте объекты и вырезайте фоны.' },
    watermarkImage: { title: 'ВОДЯНОЙ ЗНАК', desc: 'Добавьте изображение или текст на ваши фото за секунды. Выбирайте типографику, прозрачность и положение.' },
  },
  whyChoose: {
    label: 'Почему мы',
    heading: 'Умный способ редактировать изображения',
    subheading: 'Нам доверяют тысячи создателей, дизайнеров и разработчиков по всему миру. Вот почему photremium.com — лучший выбор для редактирования изображений.',
    reasons: {
      fast: { title: 'Молниеносная скорость', desc: 'Вся обработка происходит прямо в вашем браузере. Никакой загрузки файлов на внешние серверы — результаты появляются за миллисекунды.' },
      private: { title: '100% Конфиденциально', desc: 'Ваши файлы никогда не покидают устройство. Мы не храним, не передаём и не получаем доступ к вашим изображениям. Полная конфиденциальность гарантирована.' },
      noLimits: { title: 'Без ограничений', desc: 'Используйте каждый инструмент столько раз, сколько хотите — абсолютно бесплатно. Не требуется аккаунт, нет водяных знаков, нет скрытых платежей.' },
      quality: { title: 'Профессиональное качество', desc: 'Наши алгоритмы дают результаты студийного уровня. Сжимайте без видимых потерь, конвертируйте с идеальной точностью.' },
      batch: { title: 'Пакетная обработка', desc: 'Обрабатывайте несколько файлов одновременно. Конвертируйте, сжимайте или изменяйте размер целых папок за одну операцию.' },
      everywhere: { title: 'Работает везде', desc: 'Полностью адаптивный дизайн для компьютера, планшета и телефона. Не нужно ничего скачивать или устанавливать.' },
    },
    stats: {
      imagesProcessed: 'Обработано изображений',
      countriesServed: 'Стран охвачено',
      uptime: 'Время работы',
      freeTools: 'Бесплатных инструментов',
    },
  },
  footer: {
    tagline: 'Бесплатные онлайн-инструменты — конвертируйте, сжимайте, изменяйте размер, обрезайте и редактируйте изображения за секунды. Регистрация не требуется.',
    imageTools: 'Инструменты',
    moreTools: 'Другие инструменты',
    company: 'Компания',
    contact: 'Контакты',
    allRightsReserved: 'Все права защищены.',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Часто задаваемые вопросы',
    subheading: 'Быстрые ответы на распространённые вопросы об этом инструменте.',
    stillHaveQuestions: 'Остались вопросы? Мы готовы помочь!',
    reachOut: 'Связаться с нами',
    questionHeader: 'Вопрос',
  },

  contactForm: {
    badge: 'Связаться с нами',
    title: 'Свяжитесь с нами',
    subtitle: 'Мы рады вашему обращению. Отправьте нам сообщение!',
    nameLabel: 'Имя',
    namePlaceholder: 'Ваше полное имя',
    emailLabel: 'Электронная почта',
    emailPlaceholder: 'vasha@pochta.ru',
    subjectLabel: 'Тема',
    subjectPlaceholder: 'О чём вы хотите сообщить?',
    messageLabel: 'Сообщение',
    messagePlaceholder: 'Напишите ваше сообщение здесь…',
    errName: 'Имя обязательно',
    errEmail: 'Электронная почта обязательна',
    errEmailInvalid: 'Введите корректный адрес электронной почты',
    errSubject: 'Тема обязательна',
    errMessage: 'Сообщение обязательно',
    sending: 'Отправка…',
    send: 'Отправить сообщение',
    successTitle: 'Сообщение отправлено!',
    successMsg: 'Спасибо за обращение. Мы ответим вам в ближайшее время.',
    sendAnother: 'Отправить ещё',
    sendError: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
  },

  about: {
    label: 'О нас',
    heading: 'Создано для творцов, творцами',
    subheading: 'Мы верим, что мощные инструменты для изображений должны быть бесплатными, быстрыми и доступными для всех.',
    missionTitle: 'Наша миссия',
    missionText: 'photremium.com создан с простой целью: обеспечить самый интуитивный, быстрый и конфиденциальный опыт редактирования изображений в интернете. Мы обрабатываем всё прямо в вашем браузере — ваши файлы никогда не покидают устройство. Никаких аккаунтов, никаких ограничений.',
    privacyTitle: 'Конфиденциальность прежде всего',
    privacyText: 'Мы никогда не загружаем, не храним и не обрабатываем ваши изображения на удалённых серверах. Всё остаётся на вашем устройстве.',
    techTitle: 'Современные технологии',
    techText: 'Создан с использованием передовых веб-технологий: WebAssembly, Canvas API и современный React для максимальной производительности.',
    communityTitle: 'Ориентация на сообщество',
    communityText: 'Каждая функция вдохновлена реальными отзывами пользователей. Ваши предложения определяют нашу дорожную карту.',
    globalTitle: 'Глобальный охват',
    globalText: 'Используется создателями в более чем 120 странах. Доступен на нескольких языках с молниеносной CDN-доставкой.',
  },
  seo: {
    homeTitle: 'photremium.com — Бесплатный онлайн-конвертер, компрессор и редактор изображений',
    homeDesc: 'Конвертируйте, сжимайте, изменяйте размер, обрезайте и редактируйте изображения онлайн бесплатно. Быстро, конфиденциально и безопасно.',
    homeKeywords: 'конвертер изображений, компрессор изображений, изменить размер, обрезать, фоторедактор, онлайн инструменты',
    aboutTitle: 'О photremium.com — Наша миссия и история',
    aboutDesc: 'Узнайте о photremium.com — бесплатном онлайн-наборе инструментов для изображений, которому доверяют миллионы.',
    aboutKeywords: 'о photremium.com, инструменты для изображений, бесплатный редактор',
  },
          privacyPolicyPage: {
    seo: {
      title: 'Политика конфиденциальности — Фотремиум | Никакой загрузки на сервер, нулевое хранение данных',
      description: 'Политика конфиденциальности Photremium объясняет, как мы защищаем вашу конфиденциальность. Вся обработка изображений на 100% происходит в вашем браузере — файлы не загружаются на какой-либо сервер, не собираются личные данные и не отслеживаются.',
      ogTitle: 'Политика конфиденциальности — Фотремиум | Никаких загрузок, нулевое хранилище',
      ogDescription: 'Ваши файлы остаются на вашем устройстве. Photremium обрабатывает все изображения локально в вашем браузере без контакта с сервером, хранения данных и отслеживания.',
      twitterTitle: 'Политика конфиденциальности — Фотремиум',
      twitterDescription: '100% инструменты обработки изображений на основе браузера. Никаких загрузок, никакого хранения, никакого отслеживания. Прочтите нашу полную политику конфиденциальности.',
      schemaName: 'Политика конфиденциальности - Фотремиум',
      schemaDescription: 'Политика конфиденциальности Photremium: никаких загрузок на сервер и хранения данных, 100% обработка изображений в браузере.'
    },
    hero: {
      badge: 'политика конфиденциальности',
      titlePrefix: 'Ваша конфиденциальность — наша',
      titleHighlight: 'Высший приоритет',
      subPrefix: 'Photremium.com построен по простому принципу —',
      subStrong: 'ваши файлы никогда не покидают ваше устройство',
      subSuffix: 'Каждый графический инструмент на этом сайте полностью работает внутри вашего браузера. Никаких загрузок. Никакого облака. Никаких компромиссов.',
      effectiveLabel: 'Эффективный',
      lastUpdatedLabel: 'Последнее обновление',
      worldwideLabel: 'Применяется по всему миру'
    },
    trustCards: [
      {
        title: 'Нет загрузки на сервер',
        desc: 'Ваши файлы никогда не покидают ваше устройство. Вся обработка выполняется на 100% в браузере.'
      },
      {
        title: 'Нулевое хранение данных',
        desc: 'Мы ничего не храним о вас, ваших изображениях или вашей деятельности.'
      },
      {
        title: 'Нет отслеживания',
        desc: 'Никакого отслеживания поведения, снятия отпечатков пальцев и профилирования.'
      },
      {
        title: 'GDPR дружелюбный',
        desc: 'Разработано с нуля с учетом глобальных правил конфиденциальности.'
      }
    ],
    contentsTitle: 'Содержание',
    toc: {
      overview: 'Обзор',
      'no-upload': 'Нет серверной обработки',
      'data-collect': 'Данные, которые мы собираем',
      cookies: 'Файлы cookie и хранилище',
      'third-party': 'Сторонние услуги',
      analytics: 'Аналитика',
      children: 'Конфиденциальность детей',
      rights: 'Ваши права',
      security: 'Безопасность',
      changes: 'Изменения политики',
      contact: 'Связаться с нами'
    },
    sections: {
      overview: {
        title: '1. Обзор',
        subtitle: 'Что охватывает эта политика',
        p1Prefix: 'В настоящей Политике конфиденциальности описывается, как',
        p1Middle: '(«мы», «нас» или «наш») дескрипторы — или, точнее,',
        p1Italic: 'не справляется',
        p1Suffix: 'вашу личную информацию, когда вы используете наши бесплатные онлайн-инструменты для работы с изображениями по адресу',
        p2: 'В отличие от традиционных веб-приложений, которые отправляют файлы на удаленные серверы для обработки, photremium.com использует современные API-интерфейсы браузера (Canvas API, WebAssembly, WebWorkers) для выполнения каждой операции локально на вашем устройстве. Результат: никакой передачи данных, никакого хранения, никакого риска.',
        calloutLabel: 'Простое резюме на английском языке:',
        calloutText: 'Мы не можем видеть ваши изображения, да и не хотим, а наша технология специально разработана так, что мы никогда не сможем этого сделать.'
      },
      noUpload: {
        title: '2. Никакой серверной обработки — никогда',
        subtitle: 'Как на самом деле работают наши инструменты',
        introPrefix: 'Все инструменты на photremium.com — конвертер изображений, компрессор, изменение размера, удаление фона, размытие лица, водяные знаки, обрезка и инструменты QR-кода — обрабатывают ваши файлы.',
        introStrong: '100% внутри вашего веб-браузера',
        introSuffix: 'использование клиентского JavaScript и WebAssembly.',
        points: [
          {
            label: 'Никакой загрузки файлов не происходит.',
            text: 'Когда вы выбираете файл, он считывается файловым API вашего браузера и обрабатывается в памяти — он никогда не отправляется по сети.'
          },
          {
            label: 'Ни один сервер не получит ваше изображение.',
            text: 'Наша CDN обслуживает только ресурсы HTML, CSS и JavaScript, необходимые для запуска приложения, а не ваши файлы.'
          },
          {
            label: 'Нет временного хранения.',
            text: 'Обработанные результаты существуют только в памяти вашего браузера и публикуются, когда вы закрываете страницу или уходите с нее.'
          },
          {
            label: 'Работает в автономном режиме.',
            text: 'Большинство инструментов продолжают работать без подключения к Интернету после начальной загрузки страницы — еще одно доказательство того, что сервер не задействован.'
          }
        ],
        callout: 'Вы можете убедиться в этом сами: откройте вкладку «Сеть» браузера в инструментах разработчика, выберите изображение и убедитесь, что никакие данные файла не передаются на какой-либо внешний сервер.'
      },
      dataCollect: {
        title: '3. Данные, которые мы собираем (и не собираем)',
        subtitle: 'Полная прозрачность в отношении практики использования данных',
        headers: {
          type: 'Тип данных',
          collected: 'Собрал?',
          whereWhy: 'Где/Почему'
        },
        rows: [
          {
            type: 'Ваши изображения/файлы',
            badge: 'Никогда',
            variant: 'зеленый',
            showX: true,
            whereWhy: 'Полностью обрабатывается в вашем браузере и никогда не передается'
          },
          {
            type: 'Имя / адрес электронной почты',
            badge: 'Никогда',
            variant: 'зеленый',
            showX: true,
            whereWhy: 'Для использования любого инструмента не требуется учетная запись или регистрация.'
          },
          {
            type: 'IP-адрес',
            badge: 'Минимальный',
            variant: 'серый',
            showX: false,
            whereWhy: 'Стандартные журналы веб-сервера хранятся <= 30 дней, не привязаны к личности.'
          },
          {
            type: 'Тип браузера/ОС',
            badge: 'Минимальный',
            variant: 'серый',
            showX: false,
            whereWhy: 'Отправляется вашим браузером автоматически; используется только для совместимости'
          },
          {
            type: 'Посещенные страницы/клики',
            badge: 'Агрегированный',
            variant: 'синий',
            showX: false,
            whereWhy: 'Только анонимная аналитика (без идентификации личности)'
          },
          {
            type: 'Языковые предпочтения',
            badge: 'Только местное',
            variant: 'синий',
            showX: false,
            whereWhy: 'Сохранено в localStorage на вашем устройстве — никогда не отправляется нам.'
          },
          {
            type: 'Платежные/финансовые данные',
            badge: 'Никогда',
            variant: 'зеленый',
            showX: true,
            whereWhy: 'Photremium.com полностью бесплатен и не требует никаких платежей.'
          }
        ]
      },
      cookies: {
        title: '4. Файлы cookie и локальное хранилище',
        subtitle: 'Что хранится на вашем устройстве',
        intro: 'Photremium.com не использует файлы cookie рекламного характера, файлы cookie межсайтового отслеживания и сторонние файлы cookie. Единственное хранилище браузера, которое мы используем, предназначено для основных функций сайта.',
        points: [
          {
            label: 'Языковые предпочтения',
            text: 'Хранится в localStorage, поэтому сайт запоминает предпочитаемый вами язык между посещениями. Никогда не отправлялось на наши серверы.'
          },
          {
            label: 'Настройки темы/UI',
            text: 'Если вы установили предпочтения отображения, они сохраняются только локально на вашем устройстве.'
          },
          {
            label: 'Нет файлов cookie сеанса.',
            text: 'На сайте photremium.com нет системы входа в систему, поэтому файлы cookie идентификатора сеанса никогда не записываются.'
          }
        ],
        callout: 'Вы можете очистить все локальное хранилище photremium.com в любое время через настройки браузера (Настройки -> Конфиденциальность -> Очистить данные просмотра -> Кэшированные данные и файлы cookie). Это не повлияет на вашу способность использовать инструменты.'
      },
      thirdParty: {
        title: '5. Сторонние сервисы',
        subtitle: 'Внешние сервисы, которые мы используем и почему',
        intro: 'Photremium.com использует минимальный набор доверенных сторонних сервисов исключительно для обеспечения инфраструктуры и производительности. Ни одна из этих служб не получает ваши изображения или любую личную информацию.',
        headers: {
          service: 'Услуга',
          purpose: 'Цель',
          dataShared: 'Общие данные',
          privacyPolicy: 'политика конфиденциальности'
        },
        rows: [
          {
            service: 'Страницы Cloudflare',
            purpose: 'Хостинг и CDN доставка ресурсов сайта',
            dataShared: 'IP-адрес, HTTP-заголовки (стандартно)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Шрифт Awesome',
            purpose: 'Иконочные шрифты, загруженные из CDN',
            dataShared: 'IP-адрес (только запрос CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Google Шрифты',
            purpose: 'Загрузка шрифта (если применимо)',
            dataShared: 'IP-адрес (только запрос шрифта)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Мы не передаем ваши данные рекламодателям, брокерам данных или любым другим третьим лицам, кроме поставщиков инфраструктуры, перечисленных выше.'
      },
      analytics: {
        title: '6. Аналитика',
        subtitle: 'Совокупные данные об использовании с соблюдением конфиденциальности.',
        introPrefix: 'Чтобы понять, какие инструменты популярны и как улучшить сайт, мы можем собирать',
        introStrong: 'агрегированные, анонимизированные',
        introSuffix: 'статистика использования, такая как:',
        points: [
          'Количество просмотров страниц на один инструмент (без идентификации пользователя)',
          'Источник реферала (например, поиск Google, прямая ссылка) — никаких персональных данных.',
          'Географические данные на уровне страны (а не город или точное местоположение)',
          'Тип браузера/устройства для анализа совместимости'
        ],
        calloutLabel: 'Никакие данные не связаны лично с вами.',
        calloutText: 'Мы не используем Google Analytics или Meta Pixel. Любая аналитика, которую мы используем, является инструментом, ориентированным на конфиденциальность (например, «Правдоподобный» или аналогичный).'
      },
      children: {
        title: '7. Конфиденциальность детей',
        subtitle: 'COPPA и соответствие требованиям безопасности детей',
        p1: 'photremium.com сознательно не собирает какую-либо личную информацию от детей в возрасте до 13 лет (или 16 лет в Европейском Союзе в соответствии с GDPR). Поскольку мы не собираем никаких персональных данных ни от одного пользователя, юным пользователям делать особо нечего — сайт одинаково безопасен для всех.',
        p2Prefix: 'Если вы считаете, что ребенок каким-то образом предоставил личную информацию через нашу контактную форму, немедленно свяжитесь с нами по адресу:',
        p2Suffix: 'и мы оперативно удалим его.'
      },
      rights: {
        title: '8. Ваши права',
        subtitle: 'GDPR, CCPA и глобальные права на конфиденциальность',
        intro: 'Поскольку photremium.com не собирает никакой личной информации, большинство прав субъектов данных применяются тривиально — нет данных о вас, к которым можно было бы получить доступ, исправить или удалить. Тем не менее, мы полностью признаем и уважаем следующие права:',
        points: [
          {
            label: 'Право на доступ',
            text: 'Вы можете запросить копию любых данных о вас, которые мы храним. (Нет ничего, кроме анонимных журналов.)'
          },
          {
            label: 'Право на исправление',
            text: 'Вы можете запросить исправление неточных персональных данных.'
          },
          {
            label: 'Право на удаление («Право на забвение»)',
            text: 'Вы можете запросить удаление любых личных данных, которые мы храним (статья 17 GDPR, CCPA).'
          },
          {
            label: 'Право на возражение / отказ',
            text: 'Вы можете отказаться от любого сбора аналитической информации в будущем, используя инструмент отказа или блокировки рекламы на уровне браузера.'
          },
          {
            label: 'Право на переносимость данных',
            text: 'Вся ваша работа загружается непосредственно на ваше устройство — запрос на экспорт не требуется.'
          }
        ],
        callout: 'Эти права распространяются на всех пользователей по всему миру, независимо от юрисдикции — мы применяем высочайший стандарт (GDPR) в качестве базового уровня.'
      },
      security: {
        title: '9. Безопасность',
        subtitle: 'Как мы защищаем ваш опыт',
        intro: 'Наиболее безопасные данные — это данные, которые никогда не собираются. Клиентская архитектура photremium.com означает, что взлом сервера не может раскрыть ваши файлы, поскольку ваши файлы никогда не находятся на наших серверах. Дополнительные меры безопасности включают в себя:',
        points: [
          {
            label: 'Применение HTTPS',
            text: 'Весь трафик между вашим браузером и нашей CDN шифруется с помощью TLS 1.2+ с HSTS.'
          },
          {
            label: 'Политика безопасности контента (CSP)',
            text: 'Строгие заголовки предотвращают выполнение межсайтовых сценариев и внедрение встроенных сценариев.'
          },
          {
            label: 'Регулярный аудит зависимостей',
            text: 'Мы регулярно проверяем и обновляем пакеты npm, чтобы исправить известные уязвимости.'
          }
        ],
        disclosurePrefix: 'Ответственное раскрытие информации',
        disclosureTextPrefix: 'Обнаружили проблему безопасности? Напишите нам по адресу',
        disclosureTextSuffix: 'и мы ответим в течение 48 часов.'
      },
      changes: {
        title: '10. Изменения в настоящей Политике',
        subtitle: 'Как мы обрабатываем обновления политик',
        intro: 'Мы можем время от времени обновлять настоящую Политику конфиденциальности, чтобы отражать изменения в нашей практике, инструментах или юридических требованиях. Когда мы делаем:',
        points: [
          {
            label: '«Последнее обновление»',
            text: 'дата вверху этой страницы будет изменена.'
          },
          {
            label: 'Существенные изменения',
            text: 'будет сообщено посредством заметного уведомления на главной странице в течение как минимум 30 дней.'
          },
          {
            label: 'Предыдущие версии',
            text: 'настоящей политики будут заархивированы и доступны по запросу.'
          }
        ],
        outro: 'Продолжение использования сайта photremium.com после публикации изменений означает принятие обновленной политики. Мы рекомендуем вам периодически просматривать эту страницу.'
      },
      contact: {
        title: '11. Запросы контактов и данных',
        subtitle: 'Свяжитесь с нами по вопросам конфиденциальности',
        p1Prefix: 'По любым вопросам, проблемам или официальным запросам данных, связанным с настоящей Политикой конфиденциальности, свяжитесь с нами. Мы стремимся отвечать на все запросы, связанные с конфиденциальностью, в рамках',
        p1Strong: '5 рабочих дней'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Вопросы конфиденциальности?',
      privacyQuestionsDesc: 'Присылайте нам свои вопросы о конфиденциальности, запросы на предоставление данных или проблемы, и мы оперативно ответим.',
      versionHistoryTitle: 'История версий',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: 'Новинка!',
    download: 'Скачать',
    downloadAll: 'Скачать всё',
    downloadAs: 'Скачать как:',
    zip: 'ZIP',
    separate: 'По отдельности',
    upload: 'Загрузить',
    dragDrop: 'Перетащите изображения сюда или нажмите для выбора',
    remove: 'Удалить',
    reset: 'Сбросить',
    apply: 'Применить',
    cancel: 'Отмена',
    clear: 'Очистить',
    close: 'Закрыть',
    save: 'Сохранить',
    processing: 'Обработка...',
    noFiles: 'Файлы не выбраны',
    selectFiles: 'Выберите файлы',
    or: 'или',
    browseFiles: 'выбрать файлы',
    dropHere: 'Перетащите изображения сюда',
    chooseFiles: 'Выберите файлы',
    pasteHint: 'Вы также можете вставить изображения с помощью',
    quality: 'Качество',
    width: 'Ширина',
    height: 'Высота',
    format: 'Формат',
    compression: 'Сжатие',
    preview: 'Предпросмотр',
    original: 'Оригинал',
    result: 'Результат',
    before: 'До',
    after: 'После',
    startOver: 'Начать заново',
    startOverConfirm: 'Вы уверены, что хотите удалить все изображения и начать заново?',
    addMoreImages: 'Добавить изображения',
    addImage: 'Добавить изображение',
    images: 'Изображения',
    totalSize: 'Общий размер',
    size: 'Размер',
    type: 'Тип',
    unsavedEdits: 'Есть несохранённые изменения. Покинуть страницу?',
    compareSlider: 'Ползунок сравнения',
    toggleToolsPanel: 'Показать/скрыть панель инструментов',
    closePanel: 'Закрыть панель',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    fit: 'По размеру',
    none: 'Нет',
  },
  compressor: {
    seo: {
      uploadTitle: 'Компрессор изображений — Сжать JPG, PNG, SVG, GIF онлайн бесплатно | photremium.com',
      uploadDesc: 'Сжимайте JPG, PNG, SVG и GIF онлайн бесплатно. Уменьшайте размер файла до 80%, сохраняя визуальное качество.',
      uploadKeywords: 'компрессор изображений, сжать jpg, сжать png, уменьшить размер изображения',
      workspaceTitle: 'Сжатие изображений — photremium.com',
      workspaceDesc: 'Настройте уровень сжатия и скачайте оптимизированные изображения.',
      workspaceKeywords: 'сжать изображения, компрессия изображений',
    },
    title: 'Компрессор изображений',
    desc: 'Сжимайте JPG, PNG и GIF до 80% меньше. Быстро, конфиденциально — работает полностью в вашем браузере.',
    toCompress: 'для сжатия',
    compressionForAll: 'Сжатие для всех изображений',
    summary: 'Итог',
    originalSize: 'Исходный размер',
    compressed: 'Сжато',
    saved: 'Сэкономлено',
    compressionLabel: 'Сжатие:',
    compressing: 'Сжатие…',
    compressDownload: 'Сжать и скачать',
    lowQualityWarning: 'Высокое сжатие может заметно снизить четкость изображения.',
    blog: {
      tocTitle: 'Содержание',
      title: 'Блог о сжатии изображений',
      formatsIntro: 'Наш инструмент поддерживает все форматы изображений, поэтому вы можете без проблем сжать любую картинку. Ниже приведён полный список форматов:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Что такое компрессор изображений?',
          paragraphs: [
            'Компрессор изображений — это программа или онлайн-сервис, который уменьшает размер файла изображения, сохраняя его визуальное качество. Однако чрезмерное сжатие может заметно ухудшить качество.',
          ],
          listTitle: 'ТИПЫ:',
          bullets: [
            'Сжатие с потерями: размер файла уменьшается за счёт удаления части данных изображения. Качество может снизиться, но часто это почти незаметно для глаза.',
            'Сжатие без потерь: уменьшает размер файла без видимого ухудшения качества изображения.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Почему выбирают наш инструмент?',
          bullets: [
            'Наш компрессор изображений на базе ИИ работает на всех устройствах и выдаёт максимально качественный результат.',
            'Вы можете сжимать сразу несколько изображений (даже более 100) одним кликом.',
            'Не нужно загружать изображения на сервер — всё сжатие выполняется локально в вашем браузере.',
            'Наш инструмент полностью бесплатный навсегда. Вы также можете поделиться им с друзьями.',
            'Вы сами выбираете процент сжатия под свои задачи.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Пошаговое руководство',
          steps: [
            {
              heading: '1. Выберите изображения, которые хотите сжать.',
              bullets: [
                'Перетащите изображения в область загрузки.',
                'Также можно скопировать изображения и вставить в область с помощью (Ctrl + V).',
                'Можно выбрать файлы через проводник, нажав кнопку выбора.',
              ],
            },
            {
              heading: '2. Затем выберите процент сжатия.',
              bullets: [
                'Горизонтальный ползунок позволяет удобно выбрать уровень сжатия. Ориентируйтесь на диапазоны ниже для точного результата.',
              ],
              table: {
                headers: ['Процент сжатия', 'Результат'],
                rows: [
                  ['1%  до  40%', 'Лучшее качество'],
                  ['41%  до  60%', 'Нормальное качество (рекомендуется)'],
                  ['61%  до  100%', 'Низкое качество'],
                ],
              },
            },
            {
              heading: '3. Проверьте, сколько места вы сэкономили.',
              paragraphs: [
                'Все показатели отображаются в реальном времени. Вы сразу видите, сколько места удалось сэкономить от общего объёма и можете настроить уровень сжатия под нужный размер файла.',
              ],
            },
            {
              heading: '4. Выберите вариант загрузки через переключатель.',
              bullets: [
                'ZIP: если вы сжимаете несколько изображений, будет доступен этот вариант. Он соберёт все сжатые изображения в один ZIP-файл (рекомендуется для большого количества файлов).',
                'Отдельно: при выборе этого варианта каждое изображение будет скачано отдельно, а не одним ZIP-файлом (рекомендуется для небольшого количества — менее 10).',
              ],
            },
            {
              heading: '5. Сожмите и скачайте изображения.',
              paragraphs: [
                'Эта кнопка автоматически скачает все сжатые изображения в выбранном вами формате загрузки.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Преимущества компрессора изображений.',
          bullets: [
            'Снижение затрат на хранение: сжатие уменьшает размер файлов и экономит место.',
            'Более быстрая загрузка: сжатые изображения открываются быстрее и улучшают пользовательский опыт сайта или приложения.',
            'Решение ограничения Gmail: так как Gmail ограничивает вложения до 25 МБ, сжатие позволяет отправлять больше файлов.',
            'Быстрая передача и обмен: большие файлы передаются дольше, а сжатие экономит время и трафик.',
            'Оптимизация презентаций: 20 несжатых изображений могут сильно утяжелить файл, а сжатые значительно уменьшают итоговый размер.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Поддерживаемые форматы.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  converter: {
    seo: {
      uploadTitle: 'Конвертер изображений — Конвертировать PNG, JPG, WEBP, GIF, SVG онлайн | photremium.com',
      uploadDesc: 'Конвертируйте изображения между JPG, PNG, WEBP, GIF, SVG, TIFF, BMP. Бесплатно, быстро, без регистрации.',
      uploadKeywords: 'конвертер изображений, png в jpg, jpg в png, конвертер webp',
      workspaceKeywords: 'конвертировать изображения, конвертер форматов',

      routeKeywords: {

        'png-to-jpg': 'png для конвертации jpg, png to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-png': 'jpg для конвертации png, jpg to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'png-to-webp': 'png для конвертации webp, png to webp, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-webp': 'jpg для конвертации webp, jpg to webp, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'webp-to-jpg': 'webp для конвертации jpg, webp to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'webp-to-png': 'webp для конвертации png, webp to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'gif-to-jpg': 'gif для конвертации jpg, gif to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'gif-to-png': 'gif для конвертации png, gif to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'bmp-to-jpg': 'bmp для конвертации jpg, bmp to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'bmp-to-png': 'bmp для конвертации png, bmp to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'svg-to-png': 'svg для конвертации png, svg to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'svg-to-jpg': 'svg для конвертации jpg, svg to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'tiff-to-jpg': 'tiff для конвертации jpg, tiff to jpg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'tiff-to-png': 'tiff для конвертации png, tiff to png, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-gif': 'jpg для конвертации gif, jpg to gif, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'png-to-gif': 'png для конвертации gif, png to gif, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-bmp': 'jpg для конвертации bmp, jpg to bmp, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'png-to-bmp': 'png для конвертации bmp, png to bmp, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'webp-to-gif': 'webp для конвертации gif, webp to gif, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-ico': 'jpg для конвертации ico, jpg to ico, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'png-to-ico': 'png для конвертации ico, png to ico, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'jpg-to-svg': 'jpg для конвертации svg, jpg to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'png-to-svg': 'png для конвертации svg, png to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'webp-to-svg': 'webp для конвертации svg, webp to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'gif-to-svg': 'gif для конвертации svg, gif to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'bmp-to-svg': 'bmp для конвертации svg, bmp to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

        'tiff-to-svg': 'tiff для конвертации svg, tiff to svg, конвертер изображений, png в jpg, jpg в png, конвертер webp',

      },
    },
    title: 'Конвертер изображений',
    desc: 'Конвертируйте изображения между JPG, PNG, WEBP, GIF, SVG, TIFF, BMP и другими форматами. Пакетная конвертация нескольких файлов.',
    toConvert: 'для конвертации',
    convertSettings: 'Настройки конвертации',
    detected: 'Определено',
    convertTo: 'Конвертировать в',
    converting: 'Конвертация…',
    convertToFormat: 'Конвертировать в {format}',
    popularConversions: 'Популярные конвертации',
    convertingTo: 'Конвертация в',
    all: 'Все',
  },
  resizer: {
    seo: {
      uploadTitle: 'Изменение размера изображения онлайн — JPG, PNG, SVG, GIF бесплатно | photremium.com',
      uploadDesc: 'Изменяйте размер изображений онлайн бесплатно в пикселях или процентах.',
      uploadKeywords: 'изменить размер изображения, изменить размер jpg, изменить размер png',
      workspaceTitle: 'Изменение размера — photremium.com',
      workspaceDesc: 'Изменяйте размер изображений онлайн бесплатно.',
      workspaceKeywords: 'изменить размер изображения',
    },
    title: 'Изменить размер',
    desc: 'Задайте размеры в пикселях, процентах, сантиметрах или дюймах и мгновенно изменяйте размер JPG, PNG, SVG и GIF.',
    toResize: 'для изменения размера',
    resizeSettings: 'Настройки размера',
    resizeBy: 'Изменить размер по:',
    byPixels: 'По пикселям',
    byPercentage: 'По процентам',
    byCentimeters: 'По сантиметрам',
    byInches: 'По дюймам',
    advanced: 'Дополнительно',
    lockAspect: 'Заблокировать пропорции',
    unlockAspect: 'Разблокировать пропорции',
    dontEnlarge: 'Не увеличивать, если оригинал меньше',
    resizing: 'Изменение размера…',
    resizeDownload: 'Изменить размер и скачать',
    blog: {
      tocTitle: 'Содержание',
      title: 'Блог по изменению размера изображений',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Зачем использовать инструмент изменения размера изображений?',
          paragraphs: [
            'Инструмент изменения размера изображений — это средство/программа для изменения размеров изображения. Вы можете изменить высоту, ширину или оба параметра, чтобы получить нужный размер. Это особенно полезно для соцсетей, где есть ограничения на размер загружаемых/публикуемых изображений.',
          ],
          listTitle: 'Например:',
          bullets: [
            'Пост Instagram: 1080 x 1080px (квадрат)',
            'Пост Facebook: 1200 x 630px',
            'Пост X (Twitter): 1200 x 675px',
            'История Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Почему стоит выбрать наш инструмент изменения размера изображений?',
          paragraphs: [
            'Наш AI-инструмент позволяет изменять размер изображений точно и очень быстро. Он работает плавно на любом устройстве и не требует установки приложения. Все функции доступны онлайн прямо в браузере.',
          ],
          bullets: [
            'Вы можете изменять размер сразу у нескольких изображений (даже 100+). На мощных устройствах можно обработать 400–500 изображений за считанные секунды.',
            'Все обрабатывается локально в браузере. Изображения не нужно загружать на наш сервер, поэтому они не покидают ваше устройство.',
            'Поддерживаются разные единицы изменения размера.',
            'Можно сохранить исходные пропорции после изменения размера с помощью одного чекбокса.',
            'При работе с несколькими изображениями можно скачать их по отдельности или одним ZIP-архивом.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Пошаговое руководство',
          steps: [
            {
              heading: 'Сначала выберите изображение(я), размер которого хотите изменить. Есть несколько способов выбора.',
              bullets: [
                'Вы можете перетащить изображения в зону загрузки.',
                'Также можно вставить изображение сочетанием “Ctrl + V”.',
                'Либо нажмите кнопку “Choose Files”, чтобы выбрать через проводник файлов.',
              ],
            },
            {
              heading: 'Затем выберите единицу измерения для изменения размера. Сейчас доступны:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'После выбора единицы настройте высоту и ширину. При необходимости зафиксируйте пропорции чекбоксом.',
            },
            {
              heading: 'Если не хотите увеличивать изображение больше исходного, включите “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Далее выберите вариант скачивания.',
              bullets: [
                'Выберите ZIP, если хотите получить все измененные изображения одним zip-файлом.',
                'Выберите “separate”, если хотите скачивать каждое изображение отдельно.',
              ],
            },
            {
              heading: 'Наконец, нажмите кнопку “Resize & Download”, чтобы скачать изображения согласно выбранному варианту.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Преимущества инструмента изменения размера: главное преимущество — корректное размещение изображений на веб-страницах и в постах соцсетей.',
          tocLabel: '4. Преимущества инструмента изменения размера',
          bullets: [
            'Улучшение UX: правильный размер и аккуратное размещение изображения заметно улучшают пользовательский опыт.',
            'Подходит для соцсетей: многие платформы имеют ограничения по размерам изображений, и инструмент помогает под них подстроиться.',
            'Адаптивный дизайн: разработчикам нужны разные размеры изображений для разных устройств.',
            'Лучший выбор: вместо растягивания или агрессивной обрезки изображения изменение размера обычно дает более корректный результат.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Поддерживаемые форматы: наш инструмент изменения размера поддерживает выбор изображений любого формата. Поддерживаемые форматы перечислены ниже:',
          tocLabel: '5. Поддерживаемые форматы',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  cropper: {
    seo: {
      uploadTitle: 'Обрезка изображения онлайн — JPG, PNG, GIF бесплатно | photremium.com',
      uploadDesc: 'Легко обрезайте JPG, PNG и GIF онлайн. Визуальный редактор с предустановленными соотношениями.',
      uploadKeywords: 'обрезать изображение, обрезать jpg, обрезать png',
      workspaceTitle: 'Обрезка изображений — photremium.com',
      workspaceDesc: 'Обрезайте изображения онлайн бесплатно.',
      workspaceKeywords: 'обрезать изображение',
    },
    title: 'Обрезать изображение',
    desc: 'Обрезайте JPG, PNG, GIF и другие форматы с помощью визуального редактора. Предустановленные соотношения или свободная обрезка.',
    toCrop: 'для обрезки',
    cropSettings: 'Настройки обрезки',
    widthPx: 'Ширина (пкс)',
    heightPx: 'Высота (пкс)',
    positionX: 'Позиция X (пкс)',
    positionY: 'Позиция Y (пкс)',
    cropTemplate: 'Шаблон обрезки',
    landscape: 'Альбомная',
    portrait: 'Портретная',
    square: 'Квадрат',
    freeform: 'Произвольная',
    cropping: 'Обрезка…',
    cropDownload: 'Обрезать и скачать',
    cropDownloadAll: 'Обрезать и скачать всё',
    saveNext: 'Сохранить и далее',
    croppedNofTotal: 'Вы обрезали {n} из {total} изображений.',
    downloadN: 'Скачать {n}',
    blog: {
      tocTitle: 'Содержание',
      title: 'Блог об обрезке изображений',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Зачем использовать инструмент обрезки изображений?',
          paragraphs: [
            'Инструмент обрезки изображений — это программное средство, которое используется для обрезки изображения до нужной формы. Он широко используется, чтобы оставить нужную часть изображения и удалить внешние нежелательные области для любых целей. Инструмент предоставляет рамку обрезки, которую вы можете настроить в той позиции, где хотите обрезать.',
          ],
          listTitle: 'Например:',
          bullets: [
            'Обрезка себя из групповой фотографии.',
            'Обрезка вашего имени из списка.',
            'Обрезка индикатора загрузки из полноразмерного скриншота.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Почему стоит выбрать наш инструмент обрезки изображений?',
          paragraphs: [
            'Наш инструмент обрезки изображений позволяет точно и очень быстро обрезать изображения. Вам просто нужно отрегулировать размер рамки обрезки в нужной позиции на любом изображении. Поддерживаются почти все форматы изображений для выбора.',
          ],
          bullets: [
            'Вы можете обрезать столько изображений, сколько поддерживает ваше устройство. Если у вас устройство с высокой производительностью, вы даже можете обрезать более 100 изображений одновременно без лагов и других проблем.',
            'Ваши изображения обрабатываются в вашем локальном браузере. Не нужно загружать изображения на наш сервер, поэтому ни одно изображение не покидает ваше устройство. Вы можете обрезать личные изображения без каких-либо рисков безопасности.',
            'Многие инструменты показывают ошибку недопустимого формата изображения. Наш инструмент обрезки изображений решает эту проблему, поддерживая почти все форматы изображений.',
            'Если вы обрезаете много изображений одновременно, наш инструмент позволяет скачать обрезанные изображения архивом ZIP или отдельными файлами — как вам удобнее.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Пошаговое руководство',
          steps: [
            {
              heading: '1. Сначала выберите изображение, которое хотите обрезать. Наш инструмент также поддерживает выбор нескольких изображений одновременно.',
              bullets: [
                'Перетащите изображения в зону загрузки, чтобы обрезать их.',
                'Вы также можете выбрать изображения через файловый проводник, нажав кнопку choose files в блоке обрезки.',
                'Также поддерживается сочетание клавиш Ctrl + V для вставки изображений в зону загрузки.',
              ],
            },
            {
              heading: '2. Затем отрегулируйте размер и положение рамки обрезки на изображении для обрезки.',
            },
            {
              heading: '3. Вы также можете настроить рамку обрезки вручную, введя значения высоты, ширины, горизонтального и вертикального положения.',
            },
            {
              heading: '4. Вы также можете использовать несколько готовых шаблонов:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Затем выберите один из вариантов скачивания.',
              bullets: [
                'ZIP: выберите этот вариант, если вы обрезаете много изображений и хотите скачать все обрезанные изображения одним файлом.',
                'Separate: если вы хотите скачать все обрезанные изображения по отдельности, выберите этот вариант переключателем.',
              ],
            },
            {
              heading: '6. Затем нажмите кнопку Crop & Download, чтобы скачать все обрезанные изображения в соответствии с выбранными размерами.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Преимущества обрезки изображений: инструмент обрезки изображений дает несколько преимуществ в цифровом мире. Некоторые из них описаны ниже:',
          tocLabel: '4. Преимущества обрезки изображений',
          bullets: [
            'Подгонка изображений под рамку: инструмент обрезки помогает корректно разместить изображение в рамке. Эта рамка может быть на веб-странице или в любой социальной сети.',
            'Улучшение UX: правильное размещение изображения улучшает пользовательский опыт, поэтому инструмент обрезки значительно повышает UX.',
            'Удаление нежелательных полей: вы можете удалить нежелательные поля по краям изображения, чтобы сделать его более аккуратным.',
            'Выделение нужного объекта: вы также можете выделить себя на групповом фото.',
            'Экономия хранилища: обрезка изображения действительно экономит место, потому что лишняя область удаляется и остается только нужная часть.',
            'Оптимизация презентаций: если обычная презентация с 10 необрезанными изображениями занимает около 30 МБ, то та же презентация с обрезанными изображениями может занимать около 10 МБ.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Поддерживаемые форматы:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  photoEditor: {
    seo: {
      title: 'Фоторедактор онлайн — Редактировать фото бесплатно | photremium.com',
      desc: 'Редактируйте фото онлайн бесплатно — добавляйте текст, эффекты, рамки, стикеры и многое другое.',
      keywords: 'фоторедактор, редактор фото онлайн, редактировать фото бесплатно',
    },
    title: 'Фоторедактор',
    desc: 'Улучшайте фото с помощью текста, эффектов, рамок и стикеров. Простые инструменты для всех нужд.',
    toEdit: 'для редактирования',
    textTypography: 'Текст и типографика',
    textTypographyDesc: 'Добавляйте текст с различными шрифтами, цветами, тенями и параметрами расположения.',
    filtersEffects: 'Фильтры и эффекты',
    filtersEffectsDesc: 'Применяйте профессиональные фильтры, регулируйте яркость, контраст, насыщенность.',
    framesStickers: 'Рамки и стикеры',
    framesStickersDesc: 'Выбирайте из красивых рамок и весёлых стикеров для улучшения изображений.',
  },
  removeBg: {
    seo: {
      uploadTitle: 'Удалить фон изображения онлайн бесплатно | photremium.com',
      uploadDesc: 'Быстро удаляйте фоны изображений с высокой точностью. Бесплатно — работает в вашем браузере.',
      uploadKeywords: 'удалить фон, удаление фона, прозрачный фон',
      workspaceTitle: 'Удаление фона — photremium.com',
      workspaceDesc: 'Удаляйте фоны изображений онлайн бесплатно.',
      workspaceKeywords: 'удалить фон',
    },
    title: 'Удалить фон',
    desc: 'Мгновенно удаляйте фоны с помощью продвинутого определения краёв. 100% бесплатно, работает в вашем браузере.',
    toRemoveBg: 'для удаления фона',
    backgroundRemover: 'Удаление фона',
    processingProgress: 'Прогресс обработки',
    processingNImages: 'Обработка {n} изображений…',
    allNProcessed: 'Все {n} изображений обработаны!',
    nOfTotalDone: '{n} / {total} готово',
    fileName: 'Имя файла',
    dimensions: 'Размеры',
    status: 'Статус',
    statusDone: '✓ Готово',
    statusProcessing: '⏳ Обработка',
    statusError: '✗ Ошибка',
    statusPending: '⏸ Ожидание',
    badgeDone: 'Готово',
    badgeProcessing: 'Обработка…',
    badgeError: 'Ошибка',
    removingBg: 'Удаление фона…',
    retry: 'Повторить',
    downloading: 'Скачивание…',
    nextImage: 'Следующее изображение',
  },
  watermark: {
    seo: {
      uploadTitle: 'Водяной знак онлайн — Добавить текст и логотип бесплатно | photremium.com',
      uploadDesc: 'Добавляйте текстовые или imageовые водяные знаки к фото за секунды. Бесплатно и быстро.',
      uploadKeywords: 'водяной знак, добавить водяной знак, текстовый водяной знак',
      workspaceTitle: 'Добавление водяного знака — photremium.com',
      workspaceDesc: 'Добавляйте водяные знаки к изображениям онлайн бесплатно.',
      workspaceKeywords: 'водяной знак',
    },
    title: 'Водяной знак',
    desc: 'Добавляйте текстовые или логотипные водяные знаки. Настраивайте шрифт, непрозрачность, размер и положение.',
    toWatermark: 'для добавления водяного знака',
    watermarkTools: 'Инструменты водяного знака',
    addText: 'Добавить текст',
    addImage: 'Добавить изображение',
    layersN: 'Слои ({n})',
    noLayers: 'Слои ещё не добавлены',
    textLayer: 'Текстовый слой',
    imageLayer: 'Слой изображения',
    watermarkDownloadAll: 'Водяной знак и скачать всё',
    watermarkDownload: 'Водяной знак и скачать',
    nextImage: 'Следующее изображение',
    privateMode: 'Приватный режим',
    privateModeOn: 'Приватный режим ВКЛ: только перемещение и изменение размера…',
    privateModeHint: 'Включите приватный режим для настройки только положения и размера…',
    privateModeActive: 'Приватный режим — разрешено только перемещение, изменение размера и размера шрифта',
    selectToEdit: 'Выберите изображение или текст для редактирования',
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчёркнутый',
    bgColor: 'Цвет фона',
    textColor: 'Цвет текста',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    opacity: 'Непрозрачность',
    stroke: 'Обводка',
    strokeWidth: 'Ширина обводки',
    strokeColor: 'Цвет обводки',
    tileRepeat: 'Плитка / Повтор',
    tilePattern: 'Узор плитки',
    spacing: 'Расстояние',
    snapToCenter: 'Привязать к центру',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    flipHorizontal: 'Отразить по горизонтали',
    flipVertical: 'Отразить по вертикали',
    rotateLeft: 'Повернуть влево',
    rotateRight: 'Повернуть вправо',
    cornerRadius: 'Радиус скругления',
    borderStroke: 'Граница / Обводка',
    borderWidth: 'Ширина границы',
    color: 'Цвет',
    style: 'Стиль',
    hide: 'Скрыть',
    show: 'Показать',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    solid: 'Сплошная',
    dashed: 'Пунктирная',
    dotted: 'Точечная',
    double: 'Двойная',
    tileSingle: 'Одиночная',
    tile2x2: 'Сетка 2×2',
    tile3x3: 'Сетка 3×3',
    removeAllConfirm: 'Удалить все изображения и водяные знаки?',
    dimMismatch: 'Загруженные изображения имеют разные размеры. Для лучших результатов загружайте изображения одного разрешения.',
    clearBackground: 'Очистить фон',
    typeHere: 'Введите текст...',
    linkCorners: 'Связать углы',
    separateCorners: 'Разделить углы',
    blog: {
      tocTitle: 'Содержание',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Обзор инструмента водяных знаков',
          title: 'Как добавить водяной знак на изображения онлайн — Полное руководство по инструменту водяных знаков Photremium',
          paragraphs: [
            'Вы только что закончили редактировать красивую фотографию. Возможно, это снимок товара для магазина, портрет из клиентской сессии или цифровая работа, над которой вы трудились часами. И теперь возникает вопрос, с которым в итоге сталкивается каждый создатель: как защитить её перед публикацией?',
            'Ответ большинства профессионалов — водяной знак, и на то есть причины. Правильно расположенный водяной знак действует как постоянная подпись на работе, делает её узнаваемой, брендируемой и значительно усложняет кражу.',
            'Проблема в том, что большинство онлайн-инструментов либо слишком громоздкие, либо закрыты подпиской, либо создают настолько тяжёлый водяной знак, что полностью портят изображение.',
            'Инструмент водяных знаков Photremium создан, чтобы решить все эти проблемы. Это полностью браузерное, бесплатное, не требующее аккаунта рабочее пространство для водяных знаков, которое работает прямо в вашем браузере и никогда не загружает файлы на сервер. Всё остаётся локально, всё быстро, а уровень творческого контроля сопоставим с десктопными приложениями. В этом гайде мы покажем, как всё работает, для кого это сделано и как получать лучший результат каждый раз.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Что такое водяной знак',
          title: 'Что такое водяной знак и почему он важен?',
          paragraphs: [
            'Прежде чем переходить к инструменту, полезно понять, что делает водяной знак и почему столько фотографов, дизайнеров и контент-креаторов считают его обязательным.',
            'Водяной знак — это видимая надпись/наложение на изображении — обычно текст, логотип или знак авторского права — которое идентифицирует автора или владельца контента. В отличие от метаданных (которые скрыты внутри файла и могут быть удалены за секунды), водяной знак встроен визуально. Его нельзя удалить простым правым кликом без заметного ухудшения качества.',
          ],
          subSections: [
            {
              title: 'Почему создатели используют водяные знаки',
              paragraphs: [
                'Практические причины использования водяных знаков сводятся к трём ключевым пунктам.',
              ],
              bullets: [
                'Идентификация авторства. Когда вашу работу публикуют в соцсетях, на Pinterest или вставляют в статьи, исходная атрибуция часто теряется. Водяной знак гарантирует, что ваше имя или бренд остаются с изображением.',
                'Сдерживание краж. Большинство случайных воришек ищут самый лёгкий путь. Профессиональный, хорошо расположенный и слегка прозрачный водяной знак отправляет чёткий сигнал: это изображение принадлежит человеку, который защищает свою работу.',
                'Защита клиентского портфолио. Фотографы, которые отправляют превью до финальной оплаты, часто используют водяные знаки, чтобы предотвратить использование превью без оплаты. Ненавязчивый водяной знак решает задачу, не мешая оценке.',
              ],
            },
            {
              title: 'Кому стоит наносить водяные знаки',
              paragraphs: [
                'Если вы относитесь к одной из категорий ниже, нанесение водяного знака перед публикацией онлайн — это не опция, а необходимость:',
              ],
              bullets: [
                'Фриланс-фотографы, которые делятся галереями с клиентами',
                'Графические дизайнеры, публикующие примеры портфолио',
                'E-commerce продавцы, показывающие фото товара до лицензионных соглашений',
                'Цифровые художники, публикующие работы в соцсетях',
                'Блогеры и контент-креаторы, чьи изображения регулярно переиспользуют',
                'Контрибьюторы стоковых фото, развивающие узнаваемый бренд',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Панели рабочего пространства',
          title: 'Внутри инструмента водяных знаков Photremium: трёхпанельное рабочее пространство для реальных задач',
          paragraphs: [
            'То, что отличает инструмент водяных знаков Photremium от базовых онлайн-сервисов, — это дизайн рабочего пространства. Вместо простого “ввести текст, выбрать позицию, готово” инструмент предлагает трёхпанельную компоновку, похожую на профессиональные дизайнерские программы — но полностью в браузере и без установки.',
          ],
          subSections: [
            {
              title: 'Левая панель холста',
              paragraphs: [
                'Панель холста занимает большую часть экрана и показывает изображение с водяным знаком в реальном времени. Любое изменение — прозрачность, позиция текста, размер логотипа — сразу видно на холсте. Кнопки “предпросмотр” нет. Что видите — то и получаете.',
                'В холст встроена панель зума, позволяющая приблизиться для точного выравнивания или отдалиться для общего вида. Функция zoom-to-fit автоматически рассчитывает оптимальный масштаб под размер экрана, чтобы даже изображения высокого разрешения было удобно редактировать. Направляющие появляются при перетаскивании слоя к горизонтальному или вертикальному центру и “прилипают” к центру с точностью, сопоставимой с Photoshop.',
              ],
            },
            {
              title: 'Правая панель настроек',
              paragraphs: [
                'Правая панель — центр управления. Здесь вы управляете слоями водяных знаков, настраиваете их вид и запускаете экспорт. На десктопе панель закреплена справа. На мобильных устройствах она открывается снизу как bottom sheet — по плавающей кнопке-шестерёнке — и не перекрывает холст.',
                'Внутри правой панели расположен менеджер слоёв, где отображаются все добавленные элементы. Каждая строка показывает тип слоя (текст или изображение), его имя/содержимое и три быстрых действия: видимость (иконка глаза), блокировка позиции и удаление.',
              ],
            },
            {
              title: 'Левая лента предпросмотра (режим нескольких изображений)',
              paragraphs: [
                'Когда вы работаете с несколькими изображениями — партией фото товаров или полной фотосессией — слева появляется вертикальная лента миниатюр. Это очередь изображений с мини-превью каждого файла. Нажмите на любую миниатюру, чтобы мгновенно переключить холст на соответствующее изображение, проверяя водяной знак в разных композициях без потери настроек слоёв.',
                'Лента также показывает размер файла в KB или MB и формат (JPG, PNG, WEBP), чтобы вы всегда знали, с чем работаете.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Пошагово',
          title: 'Пошагово: как добавить водяной знак в Photremium',
          paragraphs: [
            'Этот walkthrough основан на реальной логике работы инструмента — от drag-and-drop загрузки до рендера на canvas, который навсегда “впечатывает” водяной знак перед скачиванием.',
          ],
          steps: [
            {
              heading: 'Шаг 1 — Загрузите ваши изображения',
              paragraphsBefore: [
                'Перейдите на photremium.com/watermark-image. Вы попадёте на экран загрузки с аккуратной dropzone в центре страницы.',
                'Есть три способа добавить изображение:',
              ],
              bullets: [
                'Drag and drop. Перетащите один или несколько файлов прямо в dropzone. Инструмент поддерживает стандартные форматы — JPEG, PNG, WEBP и другие. При перетаскивании появляется фиолетовая рамка и сообщение “Drop images to add for watermarking”.',
                'Click to browse. Нажмите “Choose Files” в зоне загрузки, чтобы открыть выбор файлов. Можно выбрать несколько файлов одновременно с Ctrl+Click (Windows) или Cmd+Click (Mac).',
                'Paste from clipboard. Если вы скопировали изображение в буфер обмена — из скриншота, приложения или браузера — просто нажмите Ctrl+V (или Cmd+V на Mac) на странице водяных знаков, и изображение загрузится прямо в рабочее пространство. Это работает даже при уже загруженных нескольких изображениях.',
              ],
              paragraphsAfter: [
                'После загрузки первого изображения рабочее пространство переключается на полный трёхпанельный редактор, а холст отображает изображение с автоматически рассчитанным zoom-to-fit.',
              ],
            },
            {
              heading: 'Шаг 2 — Добавьте текстовый слой водяного знака',
              paragraphsBefore: [
                'Нажмите фиолетовую кнопку “Add Text” в правой панели. На холсте появится новый текстовый слой с выделенным placeholder-текстом “Type here...”.',
                'Можно сразу печатать. Текст отображается в реальном времени на холсте белым Arial с размером по умолчанию. В верхней панели инструментов, которая появляется при выборе слоя, можно настроить все параметры текста:',
              ],
              bullets: [
                'Font family — выбор из 12 встроенных шрифтов, включая Arial, Georgia, Impact, Brush Script MT, Comic Sans MS и другие',
                'Font size — введите значение в пикселях или используйте регуляторы',
                'Bold, italic, underline — включайте любые комбинации стилей',
                'Text color — нажмите на образец цвета и выберите любой hex-цвет',
                'Background color — добавьте цветной фон под текст для эффекта бейджа',
                'Stroke (outline) — настройте толщину и цвет обводки для читабельности на светлых и тёмных фото',
                'Opacity — от 0% (невидимо) до 100% (полностью видимо); большинство водяных знаков в диапазоне 30–60%',
                'Alignment — выравнивание текста по левому краю, центру или правому краю',
                'Rotation — поворот текста на любой угол с магнитным snapping на 0°, 90°, 180° и 270°',
              ],
              paragraphsAfter: [
                'Чтобы переместить текст, просто перетащите его. Для точного позиционирования используйте стрелки на клавиатуре (Shift — шаг 10 пикселей). Для изменения размера текста тяните за одну из восьми ручек (углы и стороны) вокруг выбранного слоя.',
              ],
            },
            {
              heading: 'Шаг 3 — Добавьте слой водяного знака с изображением (логотип)',
              paragraphsBefore: [
                'Если вы хотите использовать логотип, подпись или любое изображение вместо — или вместе с — текстом, нажмите синюю кнопку “Add Image” в правой панели. Откроется выбор файла водяного знака.',
                'Инструмент автоматически масштабирует изображение водяного знака примерно до 30% ширины холста, сохраняя пропорции, и центрирует его. После этого вы можете перетаскивать, менять размер за угловые ручки (с сохранением пропорций) или вращать с помощью ручки поворота над выбранным слоем.',
                'Для изображений доступны дополнительные настройки в правой панели:',
              ],
              bullets: [
                'Opacity — как у текстовых слоёв, идеально для прозрачных PNG-логотипов',
                'Flip horizontal / Flip vertical — зеркальное отражение при необходимости',
                'Border width, border color, and border style — добавьте видимую рамку вокруг логотипа',
                'Border radius — скругляйте углы логотипа равномерно или отдельно',
                'Rotation — такое же плавное вращение, как у текстовых слоёв',
              ],
            },
            {
              heading: 'Шаг 4 — Настройте плитку (опционально)',
              paragraphsBefore: [
                'Одна из самых мощных функций — плитка: повторение водяного знака по всей картинке в виде сетки. Это особенно полезно, если вы хотите сделать изображение непригодным для перепубликации, а не просто брендировать.',
                'Выберите слой и найдите опцию tile в панели. Вы можете установить:',
              ],
              bullets: [
                'None — один экземпляр (по умолчанию)',
                'Grid 2×2 — повтор по схеме 2 столбца × 2 строки',
                'Grid 3×3 — повтор 3×3 для более плотного покрытия',
              ],
              paragraphsAfter: [
                'Также можно настроить расстояние между повторениями. Холст показывает полупрозрачные копии, чтобы вы видели полный узор до скачивания.',
              ],
            },
            {
              heading: 'Шаг 5 — Используйте менеджер слоёв для нескольких водяных знаков',
              paragraphsBefore: [
                'Вы можете добавлять сколько угодно слоёв — сочетая текстовые и графические водяные знаки. Менеджер слоёв в правой панели показывает их все. Вы можете:',
              ],
              bullets: [
                'Показывать/скрывать отдельные слои через иконку глаза — удобно для переключения между версиями без удаления',
                'Блокировать слой, чтобы избежать случайного сдвига при работе с другими слоями',
                'Удалять слой навсегда',
              ],
              paragraphsAfter: [
                'Клик по записи слоя в списке сразу выделяет его на холсте, что облегчает переключение между слоями.',
              ],
            },
            {
              heading: 'Шаг 6 — Переключайтесь между несколькими изображениями',
              paragraphsBefore: [
                'Если вы загрузили больше одного изображения, используйте ленту миниатюр слева для переключения активного холста. Настроенные слои применяются ко всем изображениям — при экспорте они будут отрендерены на каждом файле партии.',
                'Инструмент также проверяет согласованность разрешений. Если изображения значительно отличаются по размерам (более 5% по ширине или высоте), появится предупреждение о возможной разнице в позиционировании. Движок решает это пропорциональным пересчётом: позиция водяного знака рассчитывается как процент от размеров эталонного изображения и применяется к остальным, сохраняя визуальное намерение при разных разрешениях.',
              ],
            },
            {
              heading: 'Шаг 7 — Настройте параметры скачивания',
              paragraphsBefore: [
                'Для одиночного изображения нажмите “Download” под холстом, чтобы сохранить файл с водяным знаком. Имя файла автоматически получает суффикс “-watermarked” перед расширением. JPEG экспортируются с качеством 0.95 — на обычных размерах это почти неотличимо от оригинала. PNG экспортируются без потерь.',
                'Для пакетных задач доступно два режима скачивания в правой панели:',
              ],
              bullets: [
                'ZIP file — все изображения с водяным знаком упаковываются в один ZIP и скачиваются одним кликом. Инструмент динамически загружает JSZip для сжатия.',
                'Separate files — каждое изображение скачивается отдельно с небольшой задержкой между скачиваниями, чтобы избежать ограничения браузером.',
              ],
            },
            {
              heading: 'Шаг 8 — Скачайте и проверьте',
              paragraphsBefore: [
                'После нажатия кнопки скачивания (или “Watermark & Download All” для пакетной выгрузки) инструмент рендерит каждое изображение на скрытом HTML5 canvas в полном нативном разрешении — не в масштабе предпросмотра. Это означает, что экспортированный файл сохраняет 100% исходных пикселей, а водяной знак прорисован в корректной пропорции. Откройте скачанный файл и приблизьте, чтобы проверить качество и позицию водяного знака.',
                'Если что-то не так, просто вернитесь в рабочее пространство — ваши слои всё ещё там — подстройте и скачайте снова.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Профессиональные советы',
          title: 'Профессиональные советы для лучших результатов',
          bullets: [
            'Используйте полупрозрачный PNG-логотип для максимальной профессиональности. Логотип с прозрачным фоном при 40–50% непрозрачности выглядит намного аккуратнее, чем сплошной текст. Экспортируйте логотип из дизайн-инструмента в PNG с alpha-прозрачностью перед использованием как изображения.',
            'Размещайте водяной знак там, где обрезка уменьшает ценность. Правый нижний угол — самое распространённое место, но и самое лёгкое для обрезки. Для большей защиты размещайте водяной знак на важной части изображения: лице, детали продукта или фокусе. Диагональная плитка ещё сложнее удаляется без ухудшения изображения.',
            'Используйте блокировку при работе с несколькими слоями. Когда позиция основного водяного знака вас устраивает, заблокируйте слой перед добавлением вторичных слоёв, чтобы избежать случайных сдвигов.',
            'Проверяйте на светлых и тёмных участках. Белый водяной знак незаметен на светлом небе, но хорошо читается в тени. Добавьте тонкую обводку или лёгкий фон для лучшей читабельности.',
            'Горячие клавиши экономят время. Стрелки перемещают выбранный слой на 1 пиксель, Shift+Arrow — на 10 пикселей. Клавиша Delete удаляет выбранный слой мгновенно. Эти сочетания ускоряют тонкую настройку сильнее, чем перетаскивание.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Приватность и безопасность',
          title: 'Приватность и безопасность: почему обработка в браузере важна',
          paragraphs: [
            'Одна из частых тревог при использовании онлайн-инструментов — куда реально уходят изображения? В серверных сервисах ваш файл загружается на сервер провайдера, обрабатывается там и возвращается обратно. Это означает, что неопубликованные работы, фото клиентов или чувствительные продуктовые изображения проходят через чужую инфраструктуру.',
            'Инструмент Photremium обрабатывает всё локально в браузере. Изображения загружаются в память устройства через File API и никогда не передаются в интернет. Рендеринг водяного знака происходит в HTML5 canvas на JavaScript, полностью внутри вкладки браузера. Когда вы закрываете страницу или нажимаете “Start Over”, все данные освобождаются из памяти и удаляются. Ничего не хранится вне вашего устройства.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Итоговое резюме',
          title: 'Почему инструмент водяных знаков Photremium заслуживает места в вашем регулярном workflow',
          paragraphs: [
            'Онлайн-инструментов водяных знаков много. Обычно инструмент, достойный закладки, отличает сочетание скорости, контроля и доверия.',
            'Скорость важна, потому что водяные знаки не должны сильно замедлять пост-обработку. Инструмент Photremium загружается мгновенно, обрабатывает локально и экспортирует в полном разрешении за секунды — даже при больших партиях. Нет ожидания серверной обработки, очередей и времени рендера, которое растёт с числом пользователей онлайн одновременно.',
            'Контроль важен, потому что неправильно выглядящий водяной знак хуже его отсутствия — он делает ваш бренд непрофессиональным. Система слоёв, управление свойствами, предпросмотр в реальном времени и поддержка горячих клавиш дают уровень контроля, сравнимый с профессиональным десктопным софтом.',
            'Доверие важно, потому что неопубликованная работа ценна. Зная, что изображения никогда не уходят по интернету на сторонние серверы, вы можете спокойно наносить водяные знаки на клиентские фото, ещё не выпущенные продуктовые изображения и чувствительные творческие материалы без риска, связанного с обработкой данных, утечками серверов или изменением политик облачных провайдеров.',
            'Добавляете ли вы быстрое уведомление о копирайте на одно фото или обрабатываете весь съёмочный сет из 200 изображений перед отправкой клиенту, инструмент Photremium даёт всё необходимое, чтобы сделать это правильно — полностью бесплатно, полностью приватно и с достаточной творческой гибкостью, чтобы водяной знак выглядел частью изображения, а не наклейкой поверх.',
            'Перейдите на photremium.com/watermark-image и попробуйте. Ваше первое изображение с водяным знаком — буквально в тридцати секундах.',
            'Photremium предлагает набор браузерных инструментов для редактирования и обработки изображений. Все инструменты работают локально — ваши изображения остаются на вашем устройстве.',
          ],
        },
      ],
    },
  },
  qrGenerator: {
    seo: {
      inputTitle: 'Генератор QR-кода — Создать и настроить бесплатно | photremium.com',
      inputDesc: 'Создавайте QR-коды для URL, текста, WiFi, контактов, email и Google Карт. Настраивайте цвета, формы, рамки и логотипы.',
      inputKeywords: 'генератор qr-кода, создать qr-код, qr-код бесплатно',
      customizeTitle: 'Настройка QR-кода — photremium.com',
      customizeDesc: 'Настройте стиль, цвет, рамку и логотип QR-кода. Скачайте в PNG, JPG, SVG, WEBP или PDF.',
      customizeKeywords: 'настройка qr-кода, стиль qr-кода',
    },
    title: 'Генератор QR-кода',
    desc: 'Создавайте, настраивайте и скачивайте QR-коды для URL, текста, WiFi, контактов, email и карт. Полностью бесплатно.',
    generate: 'Создать',
    scanQrCode: 'Сканировать QR-код',
    tabUrl: 'Ссылка / URL',
    tabText: 'Текст',
    tabWifi: 'WiFi',
    tabContact: 'Контакт',
    tabEmail: 'Gmail',
    tabMaps: 'Google Карты',
    enterUrl: 'Введите URL',
    enterText: 'Введите текст',
    networkName: 'Имя сети (SSID)',
    password: 'Пароль',
    encryption: 'Шифрование',
    hiddenNetwork: 'Скрытая сеть',
    contactName: 'Имя контакта (необязательно)',
    phoneNumber: 'Номер телефона',
    emailAddress: 'Адрес электронной почты',
    subject: 'Тема (необязательно)',
    body: 'Текст (необязательно)',
    searchLocation: 'Поиск местоположения',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Введите текст здесь…',
    wifiNamePlaceholder: 'Моя WiFi',
    passwordPlaceholder: 'Пароль',
    contactPlaceholder: 'Иван Иванов',
    phonePlaceholder: '+7 XXX XXX XX XX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'Тема',
    bodyPlaceholder: 'Текст письма…',
    locationPlaceholder: 'Поиск города, адреса, места…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Нет',
    characters: 'символов',
    qrGettingComplex: 'QR-код становится сложным — может быть трудно сканировать.',
    qrTooComplex: 'QR-код слишком сложный! Большинство сканеров не смогут его прочитать.',
    generateCustomize: 'Создать и настроить',
    editQrData: 'Редактировать данные QR',
    styleShape: 'Стиль и форма',
    colorTab: 'Цвет',
    framesTab: 'Рамки',
    logoTab: 'Логотип',
    templatesTab: 'Шаблоны',
    fileFormatTab: 'Формат файла',
    dotShape: 'Форма точек',
    cornerEyeOuter: 'Угловой глаз — внешний',
    cornerEyeInner: 'Угловой глаз — внутренний',
    fgColor: 'Цвет переднего плана',
    bgColor: 'Цвет фона',
    enableGradient: 'Включить градиент',
    gradientType: 'Тип градиента',
    linear: 'Линейный',
    radial: 'Радиальный',
    gradientColor1: 'Цвет градиента 1',
    gradientColor2: 'Цвет градиента 2',
    suggestedGradients: 'Рекомендуемые градиенты',
    selectFrame: 'Выбрать рамку',
    selectLogo: 'Выбрать логотип',
    uploadCustomLogo: 'Или загрузить свой логотип',
    uploadImage: 'Загрузить изображение',
    customLogoApplied: 'Логотип применён',
    premadeTemplates: 'Готовые шаблоны',
    templateHint: 'Нажмите на шаблон, чтобы применить его стиль.',
    downloadFormat: 'Формат скачивания',
    fgBgIdentical: 'Цвета переднего плана и фона одинаковы — QR-код будет невидим!',
    fgBgSimilar: 'Цвета переднего плана и фона очень похожи — QR-код может быть трудно сканировать.',
    preview: 'Предпросмотр',
    angle: 'Угол',
    downloadFormatBtn: 'Скачать {format}',
    pngDesc: 'Без потерь, поддержка прозрачности',
    jpgDesc: 'Популярный/универсальный формат файла',
    webpDesc: 'Современный формат, лучшее качество/размер',
    svgDesc: 'Масштабируемая векторная графика',
    pdfDesc: 'Документ для печати',
    lat: 'Шир.:',
    lng: 'Дол.:',
    qrCode: 'QR-код',
    scanMe: 'СКАНИРУЙ',
    scanHere: 'СКАНИРУЙ ЗДЕСЬ',
    blog: {
      card1: {
        title: '1. Что такое QR-код?',
        intro1: 'Полное название QR — “Quick Response code” (код быстрого отклика). Поскольку информация в нём считывается и декодируется очень быстро, его и называют QR-кодом.',
        intro2: 'QR-код — это двумерный цифровой код, который считывается машинами. Человек не может напрямую прочитать содержащиеся в нём данные. Он состоит из блоков, где можно хранить текст, контактные данные, ссылки, локации Google Maps и другую информацию.',
        inventionTitle: 'Как был изобретён QR-код:',
        inventionText: 'QR-код был изобретён в 1994 году. Масахиро Хара и его команда работали в японской компании Denso Wave, производившей автокомпоненты для Toyota. Им нужен был код, способный хранить гораздо больше данных, чем обычный штрихкод, и так появился QR-код.',
        keyFeaturesTitle: 'Ключевые особенности QR-кода',
        keyFeatures: [
          {
            title: 'Как работает QR',
            text: 'Вы вводите текст или ссылку, а генератор создаёт QR-код в виде квадратных модулей на основе этих данных. Каждый модуль представляет бит, а каждый бит хранит символ.',
          },
          {
            title: 'Структура QR-кода',
            text: 'QR-код содержит три крупных квадратных маркера для определения ориентации и множество маленьких квадратов для хранения битов (информации).',
          },
          {
            title: 'Ёмкость данных QR-кода',
            text: 'Обычно QR-код хранит больше информации, чем штрихкод. По сути, QR-код — это продвинутая двухмерная версия штрихкода. Обычно он хранит около 200 символов. Может хранить и до 400 символов, но такой код уже может сканироваться сложнее. При объёме более 400 символов код часто становится слишком сложным для стабильного сканирования.',
          },
          {
            title: 'Обнаружение ошибок в QR-кодах',
            text: 'QR-код может оставаться считываемым даже при повреждении части данных или изменении некоторых битов. Для обнаружения и исправления ошибок применяется технология Reed-Solomon.',
          },
        ],
        errorTitle: 'Уровни коррекции ошибок QR-кода:',
        errorIntro: 'В разных сценариях используются разные уровни обнаружения и коррекции ошибок:',
        errorHeaders: {
          level: 'Уровень',
          recovery: 'Восстановление',
          bestUse: 'Лучший сценарий',
        },
        errorRows: [
          {
            level: 'Низкий (L)',
            recovery: '~7%',
            useCases: [
              'Используется, когда QR-код размещён на цифровых экранах, сайтах или в чистой среде.',
              'Подходит для небольшого объёма данных: Gmail, номер телефона или короткий текст.',
            ],
          },
          {
            level: 'Средний (M)',
            recovery: '~15%',
            useCases: [
              'Подходит для листовок и плакатов в обычных условиях, когда риск повреждения невысок.',
            ],
          },
          {
            level: 'Квартильный (Q)',
            recovery: '~25%',
            useCases: [
              'Когда QR-код размещается в более суровых условиях, например на производстве или на улице.',
              'Также подходит, если в центре размещается небольшой логотип, перекрывающий часть модулей.',
            ],
          },
          {
            level: 'Высокий (H)',
            recovery: '~30%',
            useCases: [
              'Используется при высокой вероятности серьёзного повреждения QR-кода.',
              'Когда крупные логотипы закрывают центр QR-кода.',
              'Также подходит при интенсивной стилизации дизайна QR-кода.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Почему выбрать наш генератор QR-кодов?',
        intro: 'Наш генератор делает создание QR-кодов максимально быстрым, безопасным и простым. Вы можете настроить код так, чтобы он выглядел более профессионально и соответствовал стилю вашего бизнеса. Все настройки — от цветов до размещения логотипа — доступны бесплатно навсегда.',
        strengths: [
          {
            title: 'Профессиональная настройка:',
            text: 'Вы можете создавать и настраивать любое количество QR-кодов без оплаты. Все функции полностью бесплатны: градиенты, разные формы модулей, собственные логотипы и многое другое.',
          },
          {
            title: 'Поддержка нескольких форматов:',
            text: 'Для удобства доступны разные форматы загрузки. Перед скачиванием просто выберите нужный формат. Сейчас доступны следующие форматы:',
          },
          {
            title: 'Готовые шаблоны:',
            text: 'Используйте готовые градиенты и рамки, чтобы быстро придать QR-коду профессиональный вид.',
          },
          {
            title: 'Поддержка собственного логотипа:',
            text: 'Вы можете загрузить логотип бренда, который автоматически размещается по центру QR-кода. Также можно выбрать логотип из встроенной библиотеки, где доступно более 30 вариантов.',
          },
          {
            title: 'Предпросмотр в реальном времени:',
            text: 'Во время настройки вы сразу видите все изменения в панели предпросмотра. Обновления отображаются динамически и в реальном времени.',
          },
          {
            title: 'Индикатор сканируемости:',
            text: 'При выборе цветов система показывает предупреждения и подсказки, если комбинация может ухудшить сканирование.',
          },
        ],
        formatHeaders: {
          srNo: '№',
          formats: 'Форматы',
          description: 'Описание',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Без потерь, поддержка прозрачности' },
          { no: '2', format: 'JPG', description: 'Популярный универсальный формат файла' },
          { no: '3', format: 'WEBP', description: 'Современный формат с лучшим балансом качества и размера' },
          { no: '4', format: 'SVG', description: 'Масштабируемая векторная графика' },
          { no: '5', format: 'PDF', description: 'Документ, готовый к печати' },
        ],
      },
      card3: {
        title: '3. Пошаговое руководство:',
        step1Intro: 'Сначала выберите категорию QR-кода, который хотите создать: для контакта, карты, ссылки или текста. Сейчас наш генератор QR-кодов поддерживает следующие категории:',
        categories: ['Ссылка / URL', 'Текст', 'WiFi', 'Контакт', 'Gmail', 'Google Maps'],
        step2: 'После выбора категории вставьте соответствующую информацию в текстовое поле.',
        step3Intro: 'Затем нажмите Generate & Customize, чтобы открыть панель настройки. В ней вы увидите поднавигацию со следующими опциями:',
        options: [
          {
            title: 'Стиль и форма:',
            text: 'В этом разделе можно менять форму модулей: скруглённые углы, точки, горизонтальные и вертикальные полосы, маленькие квадраты и другие варианты.',
          },
          {
            title: 'Цвет:',
            text: 'Здесь можно выбрать собственные цвета фона и переднего плана. Чтобы сделать QR-код градиентным, включите градиент: можно взять готовый из встроенной библиотеки или создать свой. Также можно менять угол линейного градиента. Поддерживается и радиальный градиент. Для более профессионального эффекта можно добавить несколько цветов.',
          },
          {
            title: 'Рамки:',
            text: 'Здесь можно выбрать подходящую рамку для QR-кода. Все рамки автоматически подгоняются под код. Достаточно выбрать вариант из встроенной библиотеки.',
          },
          {
            title: 'Логотип:',
            text: 'После выбора рамки можно выбрать логотип, который автоматически размещается по центру QR-кода. Также поддерживается загрузка собственного логотипа бренда.',
          },
          {
            title: 'Шаблоны:',
            text: 'Если не хотите настраивать стиль, форму, цвет и рамку отдельно, можно применить готовые шаблоны. Для удобства доступны несколько премиальных шаблонов, и они бесплатны навсегда.',
          },
          {
            title: 'Формат файла:',
            text: 'Наконец, выберите тип файла, в котором хотите скачать QR-код. Поддерживаются распространённые форматы, включая PNG, WEBP, SVG, PDF и другие.',
          },
          {
            title: 'Редактировать данные QR:',
            text: 'Вы также можете изменить данные QR-кода без потери выбранных настроек дизайна.',
          },
        ],
        finalStep: 'После этого просто нажмите кнопку загрузки, и QR-код в точном соответствии с вашими настройками и в выбранном формате будет мгновенно скачан бесплатно.',
      },
      card4: {
        title: '4. Преимущества:',
        intro: 'QR-код связывает физический мир с цифровым опытом. Это самый быстрый способ поделиться ссылкой, контактом или местоположением. Достаточно отсканировать QR-код, чтобы мгновенно получить доступ к информации. Поэтому он очень популярен в бизнесе и цифровой среде благодаря экономии времени и практической пользе.',
        benefits: [
          {
            title: 'Долгосрочная работа:',
            text: 'QR-коды работают бессрочно и не имеют встроенного срока действия. При сканировании они мгновенно предоставляют сохранённую информацию. Поскольку в них хранятся жёстко закодированные цифровые инструкции, данные не теряются сами по себе.',
          },
          {
            title: 'Поддержка офлайн:',
            text: 'QR-код можно сканировать даже без интернета. Камера телефона декодирует его паттерн и показывает содержащуюся в нём информацию.',
          },
          {
            title: 'Нулевая стоимость:',
            text: 'Поскольку таким кодам не нужны серверные переадресации и дополнительные ресурсы, их использование остаётся бесплатным навсегда.',
          },
        ],
      },
    },
  },
  qrScanner: {
    seo: {
      title: 'Сканер QR-кода — Сканировать QR с камеры или изображения | photremium.com',
      desc: 'Мгновенно сканируйте QR-коды с камеры или загрузив изображение. Определяйте URL, текст, WiFi, контакты. Бесплатно, быстро, конфиденциально.',
      keywords: 'сканер qr-кода, сканировать qr, считыватель qr, онлайн сканер qr',
    },
    title: 'Сканер QR-кода',
    desc: 'Мгновенно сканируйте QR-коды с камеры или загрузите изображение. Быстро, конфиденциально и безопасно.',
    generateQrCode: 'Создать QR-код',
    scan: 'Сканировать',
    cameraScanner: 'Сканер через камеру',
    uploadImage: 'Загрузить изображение',
    pointCamera: 'Наведите камеру на QR-код',
    startCamera: 'Запустить камеру',
    loading: 'Загрузка…',
    dropQrImage: 'Перетащите изображение с QR-кодом сюда',
    toScan: 'для сканирования',
    supportedFormats: 'Поддерживаются JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Ctrl+V для вставки',
    scanFromGallery: 'Сканировать из галереи',
    instantScanning: 'Мгновенное сканирование',
    instantScanningDesc: 'Обнаружение QR-кода в реальном времени с камеры или загруженных изображений',
    private100: '100% Конфиденциально',
    private100Desc: 'Вся обработка происходит в вашем браузере. Ничего не загружается',
    multiFormat: 'Мультиформат',
    multiFormatDesc: 'Определяет URL, текст, WiFi, контакты, email, телефон и многое другое',
    accessingCamera: 'Получение доступа к камере…',
    cameraDenied: 'Доступ к камере запрещён. Разрешите доступ к камере и попробуйте снова.',
    noCamera: 'На устройстве не найдена камера.',
    cameraError: 'Не удалось получить доступ к камере. Попробуйте снова.',
    videoError: 'Не удалось запустить воспроизведение видео.',
    switchError: 'Не удалось переключить камеру.',
    tryAgain: 'Попробовать снова',
    switchCamera: 'Переключить камеру',
    stop: 'Остановить',
    noQrFound: 'QR-код не найден',
    couldNotRead: 'Не удалось прочитать изображение',
    scannerFailed: 'Сканер не загрузился',
    noQrFoundDesc: 'В изображении не обнаружен QR-код. Попробуйте другое изображение или используйте сканер камеры.',
    qrScanned: 'QR-код отсканирован!',
    openLink: 'Открыть ссылку',
    copied: 'Скопировано!',
    copy: 'Копировать',
    share: 'Поделиться',
    scanAgain: 'Сканировать снова',
    network: 'Сеть',
    password: 'Пароль',
    security: 'Безопасность',
    unknown: 'Неизвестно',
    typeText: 'Текст',
    typeUrl: 'URL',
    typeWifi: 'WiFi сеть',
    typeContact: 'Карточка контакта',
    typeEmail: 'Email',
    typePhone: 'Номер телефона',
    typeSms: 'SMS',
    typeLocation: 'Местоположение',
    blog: {
      tocTitle: 'Содержание',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Зачем использовать сканер QR-кода?',
          paragraphs: [
            'Сканер QR-кода — это, по сути, камера мобильного устройства, которая декодирует информацию, хранящуюся в QR-коде. Вам нужно лишь навести камеру на QR-код: независимо от ориентации кода, сканер считывает шаблоны, обнаруживает ошибки, при необходимости исправляет их и показывает информацию внутри.',
          ],
          listTitle: 'Типы сканеров QR-кода:',
          bullets: [
            'Веб-сканер QR-кода: Вы можете сканировать QR-код через онлайн-сканеры, поддерживаемые браузером. Получить информацию можно через камеру или загрузив изображение. Для авто-перехода и других продвинутых функций можно перейти на https://photremium.com.',
            'Мобильные камеры: В некоторых современных телефонах сканер QR-кода встроен в стандартное приложение камеры. Такие камеры могут распознавать и декодировать информацию простым наведением на QR-код.',
            'Приложения: Существуют приложения, специально созданные для сканирования QR-кодов. Однако для продвинутого редиректа и многих других функций вы можете установить приложение бесплатно по ссылке: https://photremium.com.',
            'Аппаратные устройства: Также существуют аппаратные устройства для сканирования QR-кодов. Они широко используются в крупных торговых центрах для оформления покупок.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Почему выбрать наш сканер QR-кода?',
          paragraphs: [
            'Вы можете использовать множество продвинутых возможностей — от редиректа до копирования содержимого, декодированного из QR-кода. В нашем сканере QR-кода доступны и другие полезные функции, такие как:',
          ],
          bullets: [
            'Высокая скорость: Наш сканер QR-кода делает декодирование чрезвычайно быстрым. Достаточно отсканировать QR-код, и инструмент мгновенно покажет информацию с расширенными опциями: копировать текст/ссылку, открыть ссылку при обнаружении, или автоматически сохранить, если найден контакт.',
            'Без установки: Вам не нужно устанавливать отдельное приложение, чтобы пользоваться нашим сканером QR-кода. Инструмент доступен бесплатно прямо в браузере.',
            'Кроссплатформенный доступ: Вы можете использовать его на любом устройстве. Не нужно беспокоиться о версии ОС или других требованиях. Поддерживаются все версии и все устройства.',
            'Поддержка всех форматов: Поддерживаются все форматы данных, которые могут содержаться в QR-коде, включая обычный текст, WiFi, URL, контакты, Gmail и Google Maps и т.д.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Пошаговое руководство:',
          steps: [
            {
              heading: '1. Сначала выберите способ сканирования QR-кода. Для этого есть два способа:',
              subSteps: [
                {
                  heading: 'i. Способ через камеру',
                  paragraphs: [
                    'Вы можете сканировать QR-код камерой устройства, даже если используете ноутбук, ПК или любое устройство с обычной камерой. При нажатии на кнопку «Запустить камеру» появится запрос разрешения — разрешите сайту использовать камеру для QR-сканирования. Если вы случайно отказали в доступе или запрос не появляется, можно выдать доступ вручную по шагам ниже:',
                  ],
                  notes: [
                    '➔ Для Chrome (Android / Desktop):',
                    '1. Нажмите на три точки',
                    '2. Откройте Настройки',
                    '3. (Пропустите этот шаг на Android) Конфиденциальность и безопасность',
                    '4. Нажмите Настройки сайта',
                    '5. Затем в разделе разрешений нажмите Камера',
                    '6. Найдите URL нашего сайта: https://photremium.com/qr-code-scanner',
                    '7. Установите разрешение камеры на Allow в выпадающем списке.',
                    '➔ Для Safari (iPhone / iOS):',
                    '1. Нажмите значок AA или Website Settings в адресной строке.',
                    '2. Выберите Website Settings.',
                    '3. Нажмите Camera и выберите Allow.',
                    '4. Если всё ещё заблокировано: откройте Настройки iPhone > Safari > Camera и установите Ask или Allow.',
                  ],
                },
                {
                  heading: 'ii. Способ через галерею',
                  paragraphs: [
                    'Вы можете загрузить изображение QR-кода, чтобы получить информацию из него. Нажмите кнопку «Сканировать из галереи», откроется проводник файлов. Затем выберите изображение QR-кода. Поддерживаются все форматы изображений: .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz и .xbm и т.д.',
                  ],
                },
              ],
            },
            {
              heading: '2. Когда вы выбираете QR-код, отображается вся информация; вы можете скопировать, поделиться или открыть ссылку, если она обнаружена. При желании можно отсканировать снова.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Преимущества сканера QR-кода:.',
          paragraphs: [
            'Сканер QR-кода даёт множество преимуществ в цифровом мире. Он делает оплату, верификацию и доступ к информации проще и быстрее даже в офлайн-режиме.',
          ],
          bullets: [
            'Мгновенный доступ к информации: Сканирование QR-кода даёт информацию за миллисекунды. Сканер декодирует шаблоны, обнаруживает ошибки и быстро их исправляет, обеспечивая очень быстрый пользовательский опыт.',
            'Плавная коммуникация: В современную эпоху особенно важна быстрая и безопасная передача небольших данных — банковских реквизитов, информации о продукте и т.д. Сканер QR-кодов решает эту задачу, так как платежи выполняются через QR. Также Google использует QR для верификации телефона при создании нового аккаунта на ноутбуке.',
            'Электронные билеты: На автовокзалах, ж/д станциях и в аэропортах вы можете быстро подтверждать билеты без долгих очередей. Кроме того, в аэропортах устанавливают несколько QR-сканеров для уменьшения очередей. Это также снижает необходимость в персонале и помогает экономить бюджет авиакомпаний.',
            'Проверка подлинности товара: Продвинутые и премиальные бренды наносят QR-код на продукцию. Покупатель может отсканировать его и проверить подлинность товара.',
          ],
        },
      ],
    },
  },
  faceBlur: {
    seo: {
      uploadTitle: 'Размытие лица — Размыть лица на фото онлайн | photremium.com',
      uploadDesc: 'Автоматически размывайте лица с помощью ИИ-детекции. Выбирайте интенсивность, форму или эмодзи. 100% бесплатно, быстро и конфиденциально.',
      uploadKeywords: 'размытие лица, размыть лицо, обнаружение лиц, инструмент конфиденциальности',
      workspaceTitle: 'Размытие лица — photremium.com',
      workspaceDesc: 'Автоматически размывайте лица на фото. 100% бесплатно, быстро и конфиденциально.',
      workspaceKeywords: 'размытие лица',
    },
    title: 'Размытие лица',
    desc: 'Автоматически обнаруживайте и размывайте лица для защиты конфиденциальности. Выбирайте интенсивность, форму или эмодзи. 100% локально — изображения не покидают устройство.',
    toBlurFaces: 'для размытия лиц',
    autoDetection: 'Автодетекция',
    autoDetectionDesc: 'ИИ-детекция лиц находит все лица мгновенно',
    customBlur: 'Настраиваемое размытие',
    customBlurDesc: 'Настройте интенсивность, форму и стиль размытия',
    private100: '100% Конфиденциально',
    private100Desc: 'Вся обработка происходит локально в вашем браузере',
    blurTools: 'Инструменты размытия',
    faces: 'Лица',
    faceDetection: 'Обнаружение лиц',
    detecting: 'Обнаружение...',
    autoDetectFaces: 'Автоопределение лиц',
    exitManualMode: 'Выйти из ручного режима',
    manualSelect: 'Ручной выбор',
    nFaceRegions: 'Найдено {n} лиц',
    noFacesDetected: 'Лица не найдены — используйте ручной режим',
    manualHint: 'Нажмите и перетащите на изображении для рисования прямоугольника над занимаемой областью.',
    blurType: 'Тип размытия',
    blur: 'Размытие',
    emoji: 'Эмодзи',
    blurIntensity: 'Интенсивность размытия',
    strength: 'Сила',
    blurShape: 'Форма размытия',
    rectangle: 'Прямоугольник',
    ellipse: 'Окружность',
    circle: 'Круг',
    chooseEmoji: 'Выбрать эмодзи',
    blurRegionsN: 'Области размытия ({n})',
    faceN: 'Лицо {n}',
    manualRegionN: 'Ручная область {n}',
    manualN: 'Ручная {n}',
    clearAllRegions: 'Очистить все области',
    processingDots: 'Обработка...',
    downloadBlurred: 'Скачать размытое изображение',
    downloadNImages: 'Скачать {n} изображений',
    downloadDialogTitle: 'Не все изображения отредактированы',
    downloadDialogText: 'Вы отредактировали {edited} из {total} изображений.',
    downloadAll: 'Скачать всё',
    removeRegion: 'Удалить область',
    region: 'Область',
    notAllEdited: 'Не все изображения отредактированы',
    editedXofY: 'Вы отредактировали {edited} из {total} изображений.',
    nextImage: 'Следующее изображение',
  },
  faqData: {
    imageConverter: [
      { q: 'Какие форматы изображений поддерживаются?', a: 'Мы поддерживаем JPG, PNG, WEBP, SVG, GIF, BMP, ICO и TIFF. Вы можете конвертировать между любыми из этих форматов мгновенно в браузере.' },
      { q: 'Влияет ли конвертация на качество изображения?', a: 'Для форматов без потерь (PNG) качество полностью сохраняется. Для форматов с потерями (JPG, WEBP) используются оптимизированные настройки кодирования.' },
      { q: 'Есть ли ограничения по размеру файла?', a: 'Жёстких ограничений нет — загружайте несколько изображений и конвертируйте пакетно. Скорость зависит от вашего устройства, а не сервера.' },
      { q: 'Безопасны ли мои данные? Загружаются ли изображения на сервер?', a: 'Абсолютно. Вся обработка происходит в браузере на 100%. Ваши изображения никогда не покидают устройство.' },
      { q: 'Можно ли конвертировать прозрачный PNG в JPG?', a: 'Да. Так как JPG не поддерживает прозрачность, прозрачные области заполняются белым фоном по умолчанию.' },
    ],
    imageCompressor: [
      { q: 'Снижает ли сжатие качество изображения?', a: 'Нет, сжатие не ухудшает качество, если не выходить за рекомендуемые пределы. Ориентируйтесь на индикаторы: i. Сжатие 1%–40%: зелёный индикатор и сообщение «Хорошее качество». ii. Сжатие 41%–60%: жёлтый индикатор и сообщение «Нормальное качество». Этот диапазон обычно рекомендуется. iii. Сжатие 61%–100%: система показывает красное предупреждение «Плохое качество», и ухудшение может быть заметно.' },
      { q: 'Какие форматы поддерживаются для сжатия?', a: 'Наш инструмент поддерживает все перечисленные форматы:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Можно ли сжать несколько изображений одновременно?', a: 'Да, конечно. Вы можете сжимать сразу много изображений (даже 100+), если устройство это позволяет. Поскольку сжатие использует ресурсы вашего устройства, на более мощном ноутбуке, ПК или телефоне обработка будет быстрее. На слабом устройстве можно сжимать по частям — инструмент остаётся бесплатным при любом количестве партий.' },
      { q: 'Вы сохраняете или загружаете наши изображения на свои серверы?', a: 'Нет, мы никогда не загружаем и не храним ваши изображения на наших серверах. Все файлы сжимаются локально в браузере. Ваши изображения не покидают устройство, поэтому можно безопасно обрабатывать личные и приватные фото.' },
      { q: 'Этот инструмент сжатия изображений бесплатный?', a: 'Да, наш инструмент полностью бесплатный навсегда. Мы не просим оплату. Скрытых платежей нет. Все функции, включая пакетное сжатие, доступны бесплатно.' },
    ],
    cropImage: [
      { q: 'Ухудшится ли качество изображения после обрезки?', a: 'Нет, обрезка изображения никак не влияет на его визуальное качество. Обрезка лишь удаляет ненужную часть изображения. Она не изменяет пиксели той части, которая остается после обрезки. Поэтому вы можете обрезать изображения в исходном качестве без каких-либо повреждений пикселей.' },
      { q: 'Какие форматы изображений поддерживает инструмент обрезки?', a: 'Вы можете выбрать изображение в любом формате, так как наш инструмент обрезки поддерживает почти все форматы изображений. Они перечислены ниже:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Загружаются ли мои изображения на ваш сервер?', a: 'Нет, вся обработка выполняется в вашем локальном браузере. Ваши изображения никогда не загружаются на наш сервер, потому что они не покидают ваше устройство. Поэтому вы можете обрезать личные изображения с помощью нашего инструмента без какого-либо риска.' },
      { q: 'Можно ли обрезать несколько изображений одновременно?', a: 'Да, вы можете обрезать несколько изображений (даже 100+) одновременно, если ваша система это поддерживает. Поскольку обрезка использует ресурсы устройства, на высокопроизводительном ноутбуке, ПК или телефоне можно обрабатывать много изображений сразу. Если у вас устройство начального уровня, вы можете обрезать изображения пакетами, так как инструмент бесплатен даже при одновременной обработке большого количества изображений.' },
      { q: 'Этот инструмент обрезки изображений бесплатный?', a: 'Да, этот инструмент обрезки изображений полностью бесплатен навсегда. Вы можете пользоваться им где угодно, в любое время и на любом устройстве. Вы получите адаптивный дизайн для всех устройств и никогда не увидите требование оплатить какие-либо премиум-функции. Все функции полностью бесплатны без скрытых платежей.' },
    ],
    resizeImage: [
      { q: 'Можно ли изменять размер нескольких изображений одновременно?', a: 'Конечно. Наш инструмент поддерживает одновременное изменение размера сразу нескольких изображений. Вы можете загрузить столько файлов, сколько поддерживает ваше устройство, и AI-движок обработает их вместе. Если устройство слабое, лучше обрабатывать пакетами, чтобы избежать зависаний. Всё выполняется локально без загрузки на сервер, поэтому приватность изображений сохраняется.' },
      { q: 'Этот инструмент изменения размера бесплатный?', a: 'Да, инструмент полностью бесплатный и останется таким навсегда. Для доступа к функциям не требуется платная подписка. При скачивании измененных изображений также нет скрытых платежей.' },
      { q: 'Снижается ли качество изображения при изменении размера?', a: '✅Decrease Size (downscale): Уменьшение размера изображения не ухудшает визуальное качество. В некоторых случаях уменьшенное изображение даже выглядит более резким. Поэтому уменьшение до меньших размеров обычно не приводит к потере качества.\n❌Increase Size (upscale): Увеличение изображения выше исходного размера может повлиять на визуальное качество. Чем сильнее увеличение, тем заметнее может быть потеря качества.' },
      { q: 'Безопасно ли использовать этот инструмент?', a: 'Да, наш инструмент безопасен, особенно для личных и чувствительных изображений. Все изображения обрабатываются локально на вашем устройстве, и никакие данные не покидают его. Вы можете изменять размер без рисков для конфиденциальности.' },
      { q: 'Какие форматы изображений поддерживаются?', a: 'Наш инструмент изменения размера поддерживает все форматы изображений. Вы можете выбрать изображения следующих форматов:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Как работает удаление фона?', a: 'Мы используем продвинутую модель ИИ, работающую прямо в браузере, для обнаружения объекта и отделения его от фона.' },
      { q: 'Работает ли с сложными фонами?', a: 'Да. Модель справляется с разнообразными сценами. Лучший результат при хорошем контрасте между объектом и фоном.' },
      { q: 'Можно ли удалять фон у нескольких изображений?', a: 'Да. Загрузите несколько изображений, инструмент обработает их последовательно. Скачайте все как ZIP или по одному.' },
      { q: 'В каком формате вывод?', a: 'Всегда PNG с прозрачным фоном.' },
      { q: 'Загружаются ли изображения на сервер?', a: 'Нет. Модель ИИ работает в браузере через WebAssembly. Изображения остаются на устройстве.' },
    ],
    watermarkImage: [
      { q: '1. Является ли инструмент Photremium для водяных знаков бесплатным?', a: 'Да — инструмент на photremium.com/watermark-image бесплатен и не требует аккаунта или подписки. Вы можете ставить водяные знаки на отдельные изображения или на целые пакеты без ограничений и без платных стен.' },
      { q: '2. Сколько изображений можно обрабатывать в пакетном режиме?', a: 'Инструмент поддерживает пакетную обработку. Вы можете перетащить целую папку изображений или выбрать десятки файлов в диалоговом окне — ограничение задаёт только память вашего устройства.' },
      { q: '3. Какие форматы входа и выхода поддерживаются?', a: 'Поддерживаются форматы, обрабатываемые File API браузера: JPEG, JPG, PNG, WEBP, GIF (статический), BMP и SVG. Выходной файл сохраняет формат исходника.' },
      { q: '4. Будет ли водяной знак выглядеть одинаково на изображениях с разным разрешением?', a: 'Да. Движок пропорционального позиционирования вычисляет относительное положение и масштаб для каждой целевой картинки, сохраняя внешний вид водяного знака в пакете.' },
      { q: '5. Можно ли использовать собственный логотип вместо текста?', a: 'Да. Кнопка «Add Image» позволяет загрузить PNG с прозрачным фоном, который сохранит прозрачность и будет использоваться как слой водяного знака.' },
      { q: '6. Как сделать водяной знак полупрозрачным?', a: 'Выберите слой водяного знака на холсте и настройте ползунок непрозрачности. 30–50% часто даёт профессиональный, ненавязчивый результат.' },
      { q: '7. Поддерживается ли несколько слоёв водяных знаков?', a: 'Да. Система слоёв позволяет добавлять неограниченное число слоёв: текст, логотипы, плитки и т. д., каждый со своими настройками.' },
      { q: '8. Что делает функция «tiling» и когда её использовать?', a: 'Tiling повторяет водяной знак по сетке по всей картинке — полезно, когда нужно сделать изображение непригодным для несанкционированного использования.' },
      { q: '9. Работает ли инструмент на мобильных устройствах?', a: 'Да — интерфейс адаптируется под узкие экраны: миниатюры становятся полосой, панель настроек выезжает снизу, все элементы поддерживают управление касанием.' },
      { q: '10. Приватны ли мои изображения? Отправляются ли они на сервер?', a: 'Нет — изображения не покидают ваше устройство. Весь рабочий процесс выполняется локально в браузере с использованием Canvas API; сетевых запросов с данными изображений не происходит.' },
    ],
    qrCodeGenerator: [
      { q: 'Истекает ли срок действия этого QR-кода?', a: 'Нет, срок действия этих QR-кодов не истекает, и они поддерживаются бессрочно. Поскольку они хранят жёстко закодированные инструкции в виде битов внутри квадратных модулей, информацию в них нельзя изменить или удалить. Вы сможете получить доступ к данным в коде, просто отсканировав его любой камерой даже спустя годы.' },
      { q: 'Почему мой QR-код не сканируется?', a: 'Ваш QR-код может не сканироваться по следующим причинам: i. Низкий контраст: если цвета фона и переднего плана слишком похожи, видимость QR-кода ухудшается и сканирование может не сработать. Наш инструмент предупреждает о низком контрасте и других возможных проблемах во время настройки. ii. Слишком большой объём данных: если вы кодируете очень длинный текст, QR-код становится слишком сложным и его труднее распознать. Проверка длины текста подсказывает оптимальный объём данных при генерации. iii. Размытая печать: скачивайте QR-код в высоком разрешении, например в PNG или SVG, которые поддерживаются нашим инструментом.' },
      { q: 'Можно ли добавить логотип в QR-код?', a: 'Да, конечно. Вы можете загрузить собственный логотип или выбрать логотип из встроенной библиотеки. Выбранный логотип автоматически будет аккуратно размещён в центре QR-кода.' },
      { q: 'Как я могу отсканировать QR-код?', a: 'Вы можете отсканировать QR-код камерой телефона. А для автоматического перехода по ссылке и других расширенных возможностей можно бесплатно использовать наш сканер QR-кодов по ссылке https://photremium.com/qr-code-scanner.' },
      { q: 'Сколько QR-кодов я могу создать бесплатно?', a: 'НЕОГРАНИЧЕННО! Вы можете создавать сколько угодно QR-кодов бесплатно. Все функции, настройки и шаблоны доступны всем бесплатно навсегда. Подписка для использования премиум-возможностей не требуется.' },
      { q: 'Нужно ли входить в аккаунт/регистрироваться, чтобы создать QR-код?', a: 'Нет. Просто введите текст, сгенерируйте QR-код и скачайте его после настройки. Вход и регистрация не требуются, потому что все функции доступны полностью бесплатно.' },
    ],
    qrCodeScanner: [
      { q: 'Можно ли сканировать QR-код из сохранённых изображений и скриншотов?', a: '**Да**, вы можете сканировать QR-код из сохранённых изображений или скриншотов. Наш сканер QR-кодов https://photremium.com/qr-code-scanner позволяет сканировать QR из галереи. Вам нужно только выбрать изображение, и вы получите всю информацию, извлечённую из этого QR-кода.' },
      { q: 'Нужно ли устанавливать приложение для сканера QR-кодов?', a: '**Нет**, наш веб-сканер QR-кодов позволяет сканировать QR без установки приложения. Вы можете бесплатно использовать наш продвинутый сканер QR-кодов на любом устройстве.' },
      { q: 'Почему сканер не распознаёт QR-код?', a: 'QR-код может не сканироваться по следующим причинам: i. Недостаточное освещение: сканирование в тусклом свете может вызывать проблемы. Включите фонарик и увеличьте яркость, если сканируете с экрана. ii. Расстояние: сканирование с неподходящего расстояния также вызывает ошибки. Оптимальное расстояние для сканирования QR-кода — около 10 дюймов (25 см). iii. Грязная линза камеры: QR-код может не считываться из-за загрязнённой линзы. Очистите линзу перед сканированием. «Видите рамку-сетку в сканере? Просто поместите QR-код внутрь неё для успешного сканирования.»' },
      { q: 'Сканирует ли инструмент инвертированный или цветной QR-код?', a: '**Да**, вы можете сканировать QR любого цвета и в любой ориентации. Однако при низком контрасте между фоном и передним планом сканирование может быть затруднено.' },
      { q: 'Этот инструмент бесплатный?', a: '**Да**, этот инструмент полностью бесплатный. Вы можете сканировать неограниченное количество QR-кодов бесплатно и без срока.' },
    ],
    faceBlur: [
      { q: 'Как работает обнаружение лиц?', a: 'Используется модель ИИ-обнаружения, работающая прямо в браузере. Она находит лица для применения эффекта размытия.' },
      { q: 'Можно ли выбрать лица для размытия?', a: 'Да. После обнаружения каждая область подсвечивается, вы выбираете и настраиваете интенсивность для каждой.' },
      { q: 'Какие стили размытия доступны?', a: 'Размытие по Гауссу, пикселизация или однотонное перекрытие. Интенсивность каждого эффекта регулируется.' },
      { q: 'Можно ли обрабатывать несколько изображений?', a: 'Да. Загружайте несколько, настраивайте и скачивайте все как ZIP.' },
      { q: 'Фото отправляются на сервер?', a: 'Нет. Модель работает через WebAssembly в браузере. Фото никогда не загружаются.' },
    ],
    photoEditor: [
      { q: 'Какие функции редактирования доступны?', a: 'Яркость, контраст, насыщенность, фильтры, текст, наложения, рамки, стикеры и многое другое прямо в браузере.' },
      { q: 'Поддерживаются ли отмена и повтор действий?', a: 'Да. Полная история отмены/повтора — экспериментируйте свободно.' },
      { q: 'Какие форматы поддерживаются?', a: 'JPG, PNG, WEBP и другие распространённые форматы. Экспортируйте в нужном формате.' },
      { q: 'Работает ли редактор на мобильных?', a: 'Да. Полностью адаптивный и сенсорный интерфейс.' },
      { q: 'Изображения хранятся на серверах?', a: 'Нет. Всё локально. Изображения никогда не покидают устройство.' },
    ],
  },
};

export default ru;